export interface Translations {
  common: {
    online: string;
    alert: string;
    low_battery: string;
    offline: string;
    loading: string;
    ble_devices: string;
  };
  login: {
    tagline: string;
    welcome: string;
    username_label: string;
    username_placeholder: string;
    password_label: string;
    submit: string;
    submitting: string;
    remember_me: string;
    error_credentials: string;
    error_network: string;
    error_prefix: string;
    saved_accounts: string;
    use_another_account: string;
    add_account: string;
    user_manual: string;
  };
  nav: {
    nav_section: string;
    system_section: string;
    dashboard: string;
    map: string;
    accounts: string;
    dmc: string;
    logs: string;
    settings: string;
    device: string;
    administrator: string;
    user_fallback: string;
    logout: string;
    ble_finder: string;
    support: string;
  };
  support: {
    title: string;
    subtitle: string;
    device_label: string;
    category_label: string;
    back_dashboard: string;
    cat_technical: string;
    cat_account: string;
    cat_billing: string;
    cat_other: string;
    subject_label: string;
    subject_placeholder: string;
    message_label: string;
    message_placeholder: string;
    email_label: string;
    email_placeholder: string;
    email_invalid: string;
    reply_note: string;
    submit: string;
    sending: string;
    success: string;
    error: string;
  };
  ble: {
    title: string;
    scan: string;
    stop: string;
    scanning: string;
    devices_found: string;
    empty: string;
    empty_hint: string;
    unknown_device: string;
    err_unsupported: string;
    err_disabled: string;
    err_permission: string;
    err_generic: string;
    prox_near: string;
    prox_medium: string;
    prox_far: string;
    prox_hint: string;
    signal_lost: string;
    rename: string;
    rename_placeholder: string;
    rename_save: string;
    rename_cancel: string;
    rename_reset: string;
    expert_mode: string;
    expert_hint: string;
    expert_exit: string;
    sound_on: string;
    sound_off: string;
  };
  topbar: {
    alerts: string;
    settings: string;
    dashboard_title: string;
    dashboard_sub: string;
    map_title: string;
    map_sub: string;
    accounts_title: string;
    accounts_sub: string;
    dmc_title: string;
    dmc_sub: string;
    device_search: string;
  };
  dmc: {
    col_device: string;
    col_status: string;
    col_battery: string;
    col_speed: string;
    col_gps_fix: string;
    col_last_comm: string;
    col_expiry: string;
    col_coords: string;
    no_expiry: string;
    no_fix: string;
    comm_warning: string;
    email_btn: string;
    email_title: string;
    email_sub: string;
    email_label: string;
    email_placeholder: string;
    email_send: string;
    email_sending: string;
    email_cancel: string;
    email_success: string;
    email_error: string;
  };
  dashboard: {
    loading: string;
    panel_title: string;
    active_suffix: string;
    search_placeholder: string;
    show_selected_only: string;
    overview: string;
    toggle_satellite: string;
    fab_close: string;
    info_title: string;
    imei: string;
    position_type: string;
    device_status: string;
    status_offline: string;
    status_sleeping: string;
    status_moving: string;
    status_on: string;
    status_door_open: string;
    status_door_closed: string;
    tl_red: string;
    tl_green: string;
    tl_off: string;
    motion_alarm_active: string;
    motion_arm: string;
    motion_disarm: string;
    sub_expiry: string;
    sub_sms_credits: string;
    sub_pos_credits: string;
    alert_panel_title: string;
    alert_ack: string;
    alert_ack_all: string;
    map_block_expired_title: string;
    map_block_expired_body: string;
    map_block_no_credits_title: string;
    map_block_no_credits_body: string;
    expiry_warning_title: string;
    expiry_warning_body: (days: number) => string;
    expiry_warning_dismiss: string;
    last_gps_fix: string;
    last_comm: string;
    last_command: string;
    positions: string;
    today: string;
    share: string;
    share_position_msg: string;
    battery: string;
    speed: string;
    location_title: string;
    latitude: string;
    longitude: string;
    address: string;
    photo_edit: string;
    photo_add: string;
    history_title: string;
    history_start: string;
    history_end: string;
    history_load: string;
    history_type_position: string;
    history_type_start: string;
    history_type_stop: string;
    history_type_power_up: string;
    history_type_power_down: string;
    history_type_charging: string;
    history_type_off_charge: string;
    history_type_checkin: string;
    history_type_door_open: string;
    history_type_door_closed: string;
    history_type_fence_enter: string;
    history_type_fence_leave: string;
    history_delete: string;
    history_delete_confirm_title: string;
    history_delete_confirm_body: string;
    history_delete_confirm_btn: string;
    history_loading: string;
    history_points: string;
    history_error_empty: string;
    history_error_load: string;
    api_error: string;
    admin_login_error: string;
    admin_search: string;
    admin_no_results: string;
    admin_searching: string;
    today_positions: string;
    period_positions: string;
    history_filter_events: string;
    history_filter_door_events: string;
    history_filter_fence_events: string;
    history_trips: string;
    history_trip: string;
    history_parked: string;
    history_no_trips: string;
    today_distance: string;
    period_distance: string;
    clustering: string;
    share_btn: string;
    share_title: string;
    share_sub: string;
    share_context: string;
    share_email_label: string;
    share_email_placeholder: string;
    share_send: string;
    share_sending: string;
    share_success: string;
    share_error: string;
    share_cancel: string;
    gf_btn: string;
    gf_hint: string;
    gf_hint_polygon: string;
    gf_shape_circle: string;
    gf_shape_polygon: string;
    gf_vertices: string;
    gf_radius: string;
    gf_cancel: string;
    gf_save: string;
    gf_modal_title: string;
    gf_edit_title: string;
    gf_modal_name_label: string;
    gf_modal_name_placeholder: string;
    gf_modal_devices_label: string;
    gf_modal_select_all: string;
    gf_modal_confirm: string;
    gf_modal_cancel: string;
    gf_info_radius: string;
    gf_info_devices: string;
    gf_info_no_devices: string;
    gf_info_edit: string;
    gf_info_delete: string;
    gf_save_error: string;
    gf_ble_blocked_polygon: string;
    gf_ble_blocked_radius: string;
    gf_list_title: string;
    gf_list_empty: string;
    gf_delete_confirm_title: string;
    gf_delete_confirm_body: string;
    gf_delete_confirm_btn: string;
    cmd_title: string;
    cmd_interval_label: string;
    cmd_send: string;
    cmd_sending: string;
    cmd_success: string;
    cmd_gprs_info: string;
    cmd_cooldown: string;
    cmd_error: string;
    cmd_no_credits: string;
    cmd_password_required: string;
    routing_duration: string;
    routing_distance: string;
    routing_arrival: string;
    routing_picker_title: string;
    routing_inapp: string;
    routing_waze: string;
    routing_gmaps: string;
    routing_cancel: string;
  };
  map: {
    global_view: string;
    total_tags: string;
    selected_tag: string;
    position: string;
    zone: string;
    battery: string;
    last_report: string;
    position_type: string;
    recent_history: string;
    filter_all: string;
    filter_online: string;
    filter_warning: string;
    filter_palette: string;
    filter_asset: string;
  };
  accounts: {
    title: string;
    total: string;
    create: string;
    search: string;
    col_name: string;
    col_devices: string;
    action_rename: string;
    action_password: string;
    action_delete: string;
    action_move: string;
    modal_create_title: string;
    modal_create_name: string;
    modal_create_login: string;
    modal_create_pwd: string;
    modal_create_confirm: string;
    modal_create_btn: string;
    modal_rename_title: string;
    modal_rename_label: string;
    modal_rename_btn: string;
    modal_pwd_title: string;
    modal_pwd_new: string;
    modal_pwd_confirm: string;
    modal_pwd_btn: string;
    modal_delete_title: string;
    modal_delete_msg: string;
    modal_delete_warning: string;
    modal_delete_devices_warning: (count: number) => string;
    modal_delete_confirm_label: string;
    modal_delete_btn: string;
    modal_move_title: string;
    modal_move_dest: string;
    modal_move_no_dest: string;
    modal_move_devices: string;
    modal_move_btn: string;
    modal_move_empty: string;
    cancel: string;
    pwd_mismatch: string;
    pwd_error: string;
    pwd_success: string;
    rename_error: string;
    rename_success: string;
    create_error: string;
    create_error_duplicate: string;
    create_success: string;
    move_error: string;
    move_success: string;
    delete_error: string;
    delete_success: string;
    no_accounts: string;
    select_account: string;
    notes_placeholder: string;
    notes_save: string;
    notes_success: string;
    commands_success: string;
    notes_error: string;
    commands_error: string;
    commands_label: string;
  };
  device_settings: {
    title: string;
    section_name: string;
    name_label: string;
    name_placeholder: string;
    section_contacts: string;
    contact_label: string;
    type_email: string;
    type_phone: string;
    placeholder_email: string;
    placeholder_phone: string;
    alert_geofence: string;
    alert_motion: string;
    alert_low_battery: string;
    section_battery: string;
    battery_threshold: string;
    section_auto_arm: string;
    auto_arm_info: string;
    auto_arm_toggle: string;
    auto_arm_from: string;
    auto_arm_to: string;
    auto_arm_outside: string;
    save: string;
    saved: string;
  };
  settings: {
    title: string;
    section_account: string;
    account_name_label: string;
    account_name_placeholder: string;
    section_security: string;
    current_pwd: string;
    new_pwd: string;
    confirm_pwd: string;
    pwd_mismatch: string;
    pwd_wrong_current: string;
    pwd_changed: string;
    section_preferences: string;
    date_format_label: string;
    date_dmy: string;
    date_mdy: string;
    distance_label: string;
    unit_km: string;
    unit_miles: string;
    section_language: string;
    lang_fr: string;
    lang_en: string;
    lang_it: string;
    lang_es: string;
    lang_nl: string;
    lang_de: string;
    save: string;
    saved: string;
    name_error: string;
    section_push: string;
    push_types: {
      motion: string;
      sos: string;
      power: string;
      fence: string;
    };
  };
  logs: {
    modal_title: string;
    type_alerts: string;
    type_commands: string;
    date_from: string;
    date_to: string;
    load_btn: string;
    loading: string;
    no_device: string;
    no_data: string;
    col_date: string;
    col_sent_time: string;
    col_device: string;
    col_recipient: string;
    col_message: string;
    col_command: string;
    col_status: string;
    col_send_time: string;
    col_delivered_time: string;
    col_ack_time: string;
    col_channel: string;
    status_sent: string;
    status_delivered: string;
    status_acked: string;
    status_pending: string;
    error: string;
    share_placeholder: string;
    share_btn: string;
    share_sending: string;
    share_sent: string;
    share_error: string;
  };
}

export const fr: Translations = {
  common: {
    online: 'En ligne',
    alert: 'Alerte',
    low_battery: 'Batterie faible',
    offline: 'Hors ligne',
    loading: 'Chargement…',
    ble_devices: 'Devices BLE',
  },
  login: {
    tagline: 'Logistics OS',
    welcome: 'Connectez-vous à votre espace de gestion',
    username_label: 'Utilisateur',
    username_placeholder: "Nom d'utilisateur",
    password_label: 'Mot de passe',
    submit: 'Se connecter',
    submitting: 'Connexion en cours…',
    remember_me: 'Se souvenir de moi',
    error_credentials: 'Identifiants incorrects. Veuillez réessayer.',
    error_network: 'Impossible de joindre le serveur. Vérifiez votre connexion.',
    error_prefix: 'Erreur',
    saved_accounts: 'Comptes enregistrés',
    use_another_account: 'Utiliser un autre compte',
    add_account: 'Ajouter un compte',
    user_manual: "Notice d'utilisation",
  },
  nav: {
    nav_section: 'Navigation',
    system_section: 'Paramètres',
    dashboard: 'Dashboard',
    map: 'Carte Globale',
    accounts: 'Comptes',
    dmc: 'DMC',
    logs: 'Logs',
    settings: 'Compte',
    device: 'Appareil',
    administrator: 'Administrateur',
    user_fallback: 'Utilisateur',
    logout: 'Déconnexion',
    ble_finder: 'BLE Finder',
    support: 'Support',
  },
  support: {
    title: 'Support technique',
    subtitle: 'Envoyez votre demande à notre équipe, nous vous répondrons par email.',
    device_label: 'Appareil',
    category_label: 'Catégorie',
    back_dashboard: 'Retour au tableau de bord',
    cat_technical: 'Problème technique',
    cat_account: 'Compte',
    cat_billing: 'Facturation',
    cat_other: 'Autre',
    subject_label: 'Sujet',
    subject_placeholder: 'Résumé de votre demande',
    message_label: 'Message',
    message_placeholder: 'Décrivez votre problème ou votre question…',
    email_label: 'Adresse email',
    email_placeholder: 'vous@exemple.com',
    email_invalid: 'Veuillez saisir une adresse email valide',
    reply_note: 'Réponse envoyée à :',
    submit: 'Envoyer la demande',
    sending: 'Envoi…',
    success: 'Votre demande a bien été envoyée. Notre équipe vous répondra rapidement.',
    error: 'Échec de l\'envoi de la demande. Veuillez réessayer.',
  },
  ble: {
    title: 'BLE Finder',
    scan: 'Lancer le scan',
    stop: 'Arrêter le scan',
    scanning: 'Scan en cours…',
    devices_found: 'appareil(s) détecté(s)',
    empty: 'Aucun appareil détecté',
    empty_hint: 'Lancez un scan pour découvrir les appareils BLE à proximité.',
    unknown_device: 'Appareil inconnu',
    err_unsupported: 'Le scan BLE est uniquement disponible sur l\'application mobile.',
    err_disabled: 'Veuillez activer le Bluetooth pour lancer un scan.',
    err_permission: 'Permission Bluetooth refusée. Autorisez l\'accès dans les réglages.',
    err_generic: 'Une erreur est survenue lors du scan.',
    prox_near: 'Vous êtes proche',
    prox_medium: 'Distance moyenne',
    prox_far: 'Vous êtes éloigné',
    prox_hint: 'Déplacez-vous pour ajuster la proximité.',
    signal_lost: 'Signal perdu',
    rename: 'Renommer',
    rename_placeholder: 'Nom personnalisé',
    rename_save: 'Enregistrer',
    rename_cancel: 'Annuler',
    rename_reset: 'Réinitialiser',
    expert_mode: 'Mode Expert',
    expert_hint: 'Filtre désactivé — tous les appareils BLE sont affichés',
    expert_exit: 'Quitter',
    sound_on: 'Activer le son',
    sound_off: 'Couper le son',
  },
  topbar: {
    alerts: 'Alertes',
    settings: 'Paramètres',
    dashboard_title: 'Dashboard',
    dashboard_sub: 'Gestion des appareils en temps réel',
    map_title: 'Carte Globale',
    map_sub: 'Tous les tags BLE sur la carte',
    accounts_title: 'Gestion des Comptes',
    accounts_sub: 'Création, modification et suppression de comptes',
    dmc_title: 'Device Management Console',
    dmc_sub: 'Vue d\'ensemble et gestion de tous les appareils',
    device_search: 'Rechercher un device…',
  },
  dmc: {
    col_device: 'Nom',
    col_status: 'Statut',
    col_battery: 'Batterie',
    col_speed: 'Vitesse',
    col_gps_fix: 'Dernier GPS Fix',
    col_last_comm: 'Dernière comm.',
    col_expiry: 'Expiration',
    col_coords: 'Coordonnées',
    no_expiry: '—',
    no_fix: '—',
    comm_warning: 'Aucune communication depuis plus de 24h alors que la batterie est suffisante. Le device rencontre probablement un problème. Essayez de le redémarrer ou contactez le support technique.',
    email_btn: 'Envoyer par email',
    email_title: 'Envoyer le rapport DMC',
    email_sub: 'Le rapport sera envoyé en pièce jointe au format PDF.',
    email_label: 'Adresse email',
    email_placeholder: 'destinataire@exemple.com',
    email_send: 'Envoyer',
    email_sending: 'Envoi en cours…',
    email_cancel: 'Annuler',
    email_success: 'Rapport envoyé avec succès.',
    email_error: 'Échec de l\'envoi. Veuillez réessayer.',
  },
  dashboard: {
    loading: 'Chargement…',
    panel_title: 'Devices',
    active_suffix: 'actifs',
    search_placeholder: 'Nom ou IMEI…',
    show_selected_only: 'Afficher uniquement ce device',
    overview: "Vue d'ensemble",
    toggle_satellite: 'Basculer satellite / plan',
    fab_close: 'Fermer',
    info_title: 'Informations',
    imei: 'IMEI',
    position_type: 'Type de position',
    device_status: 'Statut',
    status_offline: 'Hors ligne',
    status_sleeping: 'En veille',
    status_moving: 'En mouvement',
    status_on: 'Allumé',
    status_door_open: 'Ouvert',
    status_door_closed: 'Fermé',
    tl_red: 'Rouge',
    tl_green: 'Vert',
    tl_off: 'Éteint',
    motion_alarm_active: 'Détection mvt activée',
    motion_arm: 'Activer détection',
    motion_disarm: 'Désactiver détection',
    sub_expiry: 'Abonnement',
    sub_sms_credits: 'Crédits SMS',
    sub_pos_credits: 'Crédits positions',
    alert_panel_title: 'Alertes actives',
    alert_ack: 'Acquitter',
    alert_ack_all: 'Tout acquitter',
    map_block_expired_title: 'Abonnement expiré',
    map_block_expired_body: 'Le suivi de ce device est suspendu. Veuillez renouveler votre abonnement.',
    map_block_no_credits_title: 'Crédits positions épuisés',
    map_block_no_credits_body: 'Ce device ne dispose plus de crédits positions. Veuillez en acquérir de nouveaux.',
    expiry_warning_title: 'Abonnement bientôt expiré',
    expiry_warning_body: (days: number) => `L'abonnement de ce device expire dans ${days} jour${days > 1 ? 's' : ''}. Pensez à le renouveler pour éviter toute interruption du suivi.`,
    expiry_warning_dismiss: 'Continuer quand même',
    last_gps_fix: 'Dernier GPS Fix',
    last_comm: 'Dernière communication',
    positions: 'positions',
    today: "aujourd'hui",
    share: 'Partager',
    share_position_msg: 'Voici la position du traceur {name} en date du {datetime} : {link}',
    last_command: 'Dernière commande',
    battery: 'Batterie',
    speed: 'Vitesse',
    location_title: 'Localisation',
    latitude: 'Latitude',
    longitude: 'Longitude',
    address: 'Adresse',
    photo_edit: 'Modifier',
    photo_add: 'Téléchargez votre photo',
    history_title: 'Historique',
    history_start: 'Début',
    history_end: 'Fin',
    history_load: "Charger l'historique",
    history_type_position: 'Position',
    history_type_start: 'Démarrage',
    history_type_stop: 'Arrêt',
    history_type_power_up: 'Démarrage',
    history_type_power_down: 'Extinction',
    history_type_charging: 'En charge',
    history_type_off_charge: 'Déconnecté du chargeur',
    history_type_checkin: 'Check-in',
    history_type_door_open: 'Porte ouverte',
    history_type_door_closed: 'Porte fermée',
    history_type_fence_enter: 'Entrée de zone',
    history_type_fence_leave: 'Sortie de zone',
    history_delete: "Supprimer l'historique",
    history_delete_confirm_title: "Supprimer l'historique",
    history_delete_confirm_body: "Êtes-vous sûr de vouloir supprimer l'historique de ce device ? Cette action est irréversible.",
    history_delete_confirm_btn: 'Supprimer',
    history_loading: 'Chargement…',
    history_points: 'points',
    history_error_empty: 'Aucun point GPS pour cette période.',
    history_error_load: "Erreur lors du chargement de l'historique.",
    api_error: 'Impossible de charger les données. Vérifiez votre connexion.',
    admin_login_error: 'Impossible de se connecter à ce compte. Essayez un autre.',
    admin_search: 'Rechercher un compte…',
    admin_no_results: 'Aucun résultat',
    admin_searching: 'Recherche…',
    today_positions: "positions aujourd'hui",
    period_positions: 'positions (période)',
    history_filter_events: 'Starts / Stops uniquement',
    history_filter_door_events: 'Évènements porte uniquement',
    history_filter_fence_events: 'Enter / Leave fence uniquement',
    history_trips: 'Mode Trips',
    history_trip: 'Trajet',
    history_parked: 'Stationné',
    history_no_trips: 'Aucun trajet détecté',
    today_distance: "km aujourd'hui",
    period_distance: 'km (période)',
    clustering: 'Clustering',
    share_btn: 'Partager',
    share_title: "Partager l'historique",
    share_sub: 'Un email contenant les fichiers Excel et PDF sera envoyé à l\'adresse indiquée.',
    share_context: 'points · ',
    share_email_label: 'Adresse email',
    share_email_placeholder: 'exemple@domaine.com',
    share_send: 'Envoyer',
    share_sending: 'Envoi en cours…',
    share_success: 'Email envoyé avec succès !',
    share_error: "Erreur lors de l'envoi. Veuillez réessayer.",
    share_cancel: 'Annuler',
    gf_btn: 'Zones',
    gf_hint: 'Cliquez sur la carte pour placer la zone',
    gf_hint_polygon: 'Cliquez sur la carte pour ajouter des points',
    gf_shape_circle: 'Cercle',
    gf_shape_polygon: 'Polygone',
    gf_vertices: 'points',
    gf_radius: 'Rayon',
    gf_cancel: 'Annuler',
    gf_save: 'Enregistrer',
    gf_modal_title: 'Enregistrer la zone',
    gf_edit_title: 'Modifier la zone',
    gf_modal_name_label: 'Nom de la zone',
    gf_modal_name_placeholder: 'Ex : Entrepôt Nord',
    gf_modal_devices_label: 'Appareils concernés',
    gf_modal_select_all: 'Tous les appareils',
    gf_modal_confirm: 'Confirmer',
    gf_modal_cancel: 'Annuler',
    gf_info_radius: 'Rayon',
    gf_info_devices: 'appareil(s)',
    gf_info_no_devices: 'Aucun appareil assigné',
    gf_info_edit: 'Modifier',
    gf_info_delete: 'Supprimer',
    gf_save_error: "Erreur lors de l'enregistrement. Veuillez réessayer.",
    gf_ble_blocked_polygon: 'Les devices BLE ne peuvent pas être assignés à une zone polygonale.',
    gf_ble_blocked_radius: 'Les devices BLE ne peuvent pas être assignés à une zone circulaire de moins de 800m de rayon.',
    gf_list_title: 'Zones géographiques',
    gf_list_empty: 'Aucune zone créée',
    gf_delete_confirm_title: 'Supprimer la zone ?',
    gf_delete_confirm_body: 'Cette action est irréversible.',
    gf_delete_confirm_btn: 'Supprimer',
    cmd_title: 'Commandes',
    cmd_interval_label: 'Intervalle de pointage',
    cmd_send: 'Envoyer',
    cmd_sending: 'Envoi…',
    cmd_success: 'Commande transmise',
    cmd_gprs_info: 'La commande sera appliquée au prochain arrêt du device via GPRS.',
    cmd_cooldown: 'Prochain envoi dans',
    cmd_error: "Erreur lors de l'envoi",
    cmd_no_credits: 'Crédits SMS insuffisants pour envoyer cette commande.',
    cmd_password_required: 'Mot de passe requis',
    routing_duration: 'Durée',
    routing_distance: 'Distance',
    routing_arrival: 'Arrivée',
    routing_picker_title: 'Ouvrir avec',
    routing_inapp: 'Navigation intégrée',
    routing_waze: 'Waze',
    routing_gmaps: 'Google Maps',
    routing_cancel: 'Annuler',
  },
  map: {
    global_view: 'Vue Globale',
    total_tags: 'Tags totaux',
    selected_tag: 'Tag sélectionné',
    position: 'Position',
    zone: 'Zone',
    battery: 'Batterie',
    last_report: 'Dernier rapport',
    position_type: 'Type de position',
    recent_history: 'Historique récent',
    filter_all: 'Tous',
    filter_online: 'En ligne',
    filter_warning: 'Alertes',
    filter_palette: 'Palettes',
    filter_asset: 'Assets',
  },
  accounts: {
    title: 'Gestion des Comptes',
    total: 'comptes',
    create: 'Créer un compte',
    search: 'Rechercher un compte ou un device…',
    col_name: 'Nom',
    col_devices: 'Devices',
    action_rename: 'Renommer',
    action_password: 'Changer le mot de passe',
    action_delete: 'Supprimer',
    action_move: 'Déplacer des devices',
    modal_create_title: 'Créer un compte',
    modal_create_name: 'Nom du compte',
    modal_create_login: 'Identifiant',
    modal_create_pwd: 'Mot de passe',
    modal_create_confirm: 'Confirmer le mot de passe',
    modal_create_btn: 'Créer',
    modal_rename_title: 'Renommer le compte',
    modal_rename_label: 'Nouveau nom',
    modal_rename_btn: 'Renommer',
    modal_pwd_title: 'Changer le mot de passe',
    modal_pwd_new: 'Nouveau mot de passe',
    modal_pwd_confirm: 'Confirmer',
    modal_pwd_btn: 'Enregistrer',
    modal_delete_title: 'Supprimer le compte',
    modal_delete_msg: 'Êtes-vous sûr de vouloir supprimer le compte',
    modal_delete_warning: 'Cette action est irréversible.',
    modal_delete_devices_warning: (count: number) => `Ce compte contient ${count} device${count > 1 ? 's' : ''}. ${count > 1 ? 'Ils seront' : 'Il sera'} définitivement supprimé${count > 1 ? 's' : ''}.`,
    modal_delete_confirm_label: 'Je confirme la suppression des devices associés',
    modal_delete_btn: 'Supprimer',
    modal_move_title: 'Déplacer des devices',
    modal_move_dest: 'Compte de destination',
    modal_move_no_dest: '— Sélectionner un compte —',
    modal_move_devices: 'Devices à déplacer',
    modal_move_btn: 'Déplacer',
    modal_move_empty: 'Aucun device dans ce compte',
    cancel: 'Annuler',
    pwd_mismatch: 'Les mots de passe ne correspondent pas',
    pwd_error: 'Erreur lors de la mise à jour du mot de passe',
    pwd_success: 'Mot de passe mis à jour avec succès',
    rename_error: 'Erreur lors du renommage du compte',
    rename_success: 'Compte renommé avec succès',
    create_error: 'Erreur lors de la création du compte',
    move_error: 'Erreur lors du déplacement des devices',
    move_success: 'Devices déplacés avec succès',
    create_error_duplicate: 'Un compte avec ce nom existe déjà',
    create_success: 'Compte créé avec succès',
    delete_error: 'Erreur lors de la suppression du compte',
    delete_success: 'Compte supprimé avec succès',
    no_accounts: 'Aucun compte trouvé',
    select_account: 'Sélectionnez un compte pour voir ses devices',
    notes_placeholder: 'Notes…',
    notes_save: 'Enregistrer',
    notes_success: 'Notes enregistrées',
    commands_success: 'Paramètre mis à jour',
    notes_error: 'Erreur lors de l\'enregistrement',
    commands_error: 'Erreur lors de la mise à jour',
    commands_label: 'Accès aux commandes',
  },
  device_settings: {
    title: 'Paramètres du device',
    section_name: 'Nom du device',
    name_label: 'Nom',
    name_placeholder: 'Nom du device',
    section_contacts: 'Contacts d\'alerte',
    contact_label: 'Contact',
    type_email: 'Email',
    type_phone: 'Téléphone',
    placeholder_email: 'exemple@domaine.com',
    placeholder_phone: '+33 6 XX XX XX XX',
    alert_geofence: 'Géofence',
    alert_motion: 'Mouvement',
    alert_low_battery: 'Batterie faible',
    section_battery: 'Seuil de batterie faible',
    battery_threshold: 'Seuil',
    section_auto_arm: 'Auto Arm',
    auto_arm_info: 'Active la détection de mouvement selon un planning hebdomadaire. Pour chaque jour, définissez une plage horaire pendant laquelle l\'alarme est armée. Cochez "En dehors des heures" pour inverser la plage : l\'alarme sera active en dehors de l\'horaire défini.',
    auto_arm_toggle: 'Activer la détection de mouvement planifiée',
    auto_arm_from: 'De',
    auto_arm_to: 'À',
    auto_arm_outside: 'En dehors des heures',
    save: 'Enregistrer',
    saved: 'Paramètres enregistrés !',
  },
  settings: {
    title: 'Paramètres',
    section_account: 'Compte',
    account_name_label: 'Nom du compte',
    account_name_placeholder: 'Votre nom',
    section_security: 'Sécurité',
    current_pwd: 'Mot de passe actuel',
    new_pwd: 'Nouveau mot de passe',
    confirm_pwd: 'Confirmer le mot de passe',
    pwd_mismatch: 'Les mots de passe ne correspondent pas.',
    pwd_wrong_current: 'Le mot de passe actuel est incorrect.',
    pwd_changed: 'Mot de passe mis à jour.',
    section_preferences: 'Préférences',
    date_format_label: 'Format de date',
    date_dmy: 'JJ/MM/AAAA',
    date_mdy: 'MM/JJ/AAAA',
    distance_label: 'Unité de distance',
    unit_km: 'Kilomètres',
    unit_miles: 'Miles',
    section_language: 'Langue',
    lang_fr: 'Français',
    lang_en: 'English',
    lang_it: 'Italiano',
    lang_es: 'Español',
    lang_nl: 'Nederlands',
    lang_de: 'Deutsch',
    save: 'Enregistrer',
    saved: 'Enregistré !',
    name_error: 'Erreur lors de la mise à jour. Veuillez réessayer.',
    section_push: 'Notifications Push',
    push_types: {
      motion: 'Alerte de mouvement',
      sos: 'Alerte SOS/Panique',
      power: 'Batterie faible',
      fence: 'Alertes de zone',
    },
  },
  logs: {
    modal_title: 'Logs',
    type_alerts: 'Alertes envoyées',
    type_commands: 'Commandes envoyées',
    date_from: 'Du',
    date_to: 'Au',
    load_btn: 'Charger',
    loading: 'Chargement…',
    no_device: 'Sélectionnez un appareil pour consulter ses logs.',
    no_data: 'Aucun résultat pour cette période.',
    col_date: 'Date',
    col_sent_time: 'Heure d\'envoi',
    col_device: 'Appareil',
    col_recipient: 'Destinataire',
    col_command: 'Commande',
    col_status: 'Statut',
    col_send_time: 'Heure d\'envoi',
    col_delivered_time: 'Heure de livraison',
    col_ack_time: 'Heure d\'acquittement',
    col_channel: 'Canal',
    status_sent: 'Envoyé',
    status_delivered: 'Livré',
    status_acked: 'Acquitté',
    status_pending: 'En attente',
    col_message: 'Message',
    error: 'Erreur lors du chargement des logs.',
    share_placeholder: 'Envoyer par email…',
    share_btn: 'Envoyer',
    share_sending: 'Envoi…',
    share_sent: 'Email envoyé !',
    share_error: 'Erreur lors de l\'envoi.',
  },
};

export const en: Translations = {
  common: {
    online: 'Online',
    alert: 'Alert',
    low_battery: 'Low battery',
    offline: 'Offline',
    loading: 'Loading…',
    ble_devices: 'BLE Devices',
  },
  login: {
    tagline: 'Logistics OS',
    welcome: 'Sign in to your management portal',
    username_label: 'Username',
    username_placeholder: 'Username',
    password_label: 'Password',
    submit: 'Sign in',
    submitting: 'Signing in…',
    remember_me: 'Remember me',
    saved_accounts: 'Saved accounts',
    use_another_account: 'Use another account',
    add_account: 'Add an account',
    user_manual: 'User manual',
    error_credentials: 'Invalid credentials. Please try again.',
    error_network: 'Unable to reach the server. Check your connection.',
    error_prefix: 'Error',
  },
  nav: {
    nav_section: 'Navigation',
    system_section: 'Settings',
    dashboard: 'Dashboard',
    map: 'Global Map',
    accounts: 'Accounts',
    dmc: 'DMC',
    logs: 'Logs',
    settings: 'Account',
    device: 'Device',
    administrator: 'Administrator',
    user_fallback: 'User',
    logout: 'Log out',
    ble_finder: 'BLE Finder',
    support: 'Support',
  },
  support: {
    title: 'Technical support',
    subtitle: 'Send your request to our team, we will reply by email.',
    device_label: 'Device',
    category_label: 'Category',
    back_dashboard: 'Back to dashboard',
    cat_technical: 'Technical issue',
    cat_account: 'Account',
    cat_billing: 'Billing',
    cat_other: 'Other',
    subject_label: 'Subject',
    subject_placeholder: 'Summary of your request',
    message_label: 'Message',
    message_placeholder: 'Describe your issue or question…',
    email_label: 'Email address',
    email_placeholder: 'you@example.com',
    email_invalid: 'Please enter a valid email address',
    reply_note: 'Reply sent to:',
    submit: 'Send request',
    sending: 'Sending…',
    success: 'Your request has been sent. Our team will get back to you shortly.',
    error: 'Failed to send request. Please try again.',
  },
  ble: {
    title: 'BLE Finder',
    scan: 'Start scan',
    stop: 'Stop scan',
    scanning: 'Scanning…',
    devices_found: 'device(s) found',
    empty: 'No device detected',
    empty_hint: 'Start a scan to discover nearby BLE devices.',
    unknown_device: 'Unknown device',
    err_unsupported: 'BLE scanning is only available in the mobile app.',
    err_disabled: 'Please enable Bluetooth to start a scan.',
    err_permission: 'Bluetooth permission denied. Allow access in settings.',
    err_generic: 'An error occurred during the scan.',
    prox_near: 'You are close',
    prox_medium: 'Medium distance',
    prox_far: 'You are far',
    prox_hint: 'Move around to adjust the proximity.',
    signal_lost: 'Signal lost',
    rename: 'Rename',
    rename_placeholder: 'Custom name',
    rename_save: 'Save',
    rename_cancel: 'Cancel',
    rename_reset: 'Reset',
    expert_mode: 'Expert Mode',
    expert_hint: 'Filter off — all BLE devices shown',
    expert_exit: 'Exit',
    sound_on: 'Enable sound',
    sound_off: 'Mute',
  },
  topbar: {
    alerts: 'Alerts',
    settings: 'Settings',
    dashboard_title: 'Dashboard',
    dashboard_sub: 'Real-time device management',
    map_title: 'Global Map',
    map_sub: 'All BLE tags on the map',
    accounts_title: 'Account Management',
    accounts_sub: 'Create, edit and delete accounts',
    dmc_title: 'Device Management Console',
    dmc_sub: 'Overview and management of all devices',
    device_search: 'Search a device…',
  },
  dmc: {
    col_device: 'Name',
    col_status: 'Status',
    col_battery: 'Battery',
    col_speed: 'Speed',
    col_gps_fix: 'Last GPS Fix',
    col_last_comm: 'Last Comm.',
    col_expiry: 'Expiry',
    col_coords: 'Coordinates',
    no_expiry: '—',
    no_fix: '—',
    comm_warning: 'No communication for over 24 hours despite sufficient battery. The device is likely experiencing an issue. Try restarting it or contact technical support.',
    email_btn: 'Send by email',
    email_title: 'Send DMC report',
    email_sub: 'The report will be sent as a PDF attachment.',
    email_label: 'Email address',
    email_placeholder: 'recipient@example.com',
    email_send: 'Send',
    email_sending: 'Sending…',
    email_cancel: 'Cancel',
    email_success: 'Report sent successfully.',
    email_error: 'Failed to send. Please try again.',
  },
  dashboard: {
    loading: 'Loading…',
    panel_title: 'Devices',
    active_suffix: 'active',
    search_placeholder: 'Name or IMEI…',
    show_selected_only: 'Show selected device only',
    overview: 'Overview',
    toggle_satellite: 'Toggle satellite / map',
    fab_close: 'Close',
    info_title: 'Information',
    imei: 'IMEI',
    position_type: 'Position type',
    device_status: 'Status',
    status_offline: 'Offline',
    status_sleeping: 'Sleeping',
    status_moving: 'Moving',
    status_on: 'On',
    status_door_open: 'Open',
    status_door_closed: 'Close',
    tl_red: 'Red',
    tl_green: 'Green',
    tl_off: 'Off',
    motion_alarm_active: 'Motion detection enabled',
    motion_arm: 'Enable detection',
    motion_disarm: 'Disable detection',
    sub_expiry: 'Subscription',
    sub_sms_credits: 'SMS credits',
    sub_pos_credits: 'Position credits',
    alert_panel_title: 'Active alerts',
    alert_ack: 'Acknowledge',
    alert_ack_all: 'Acknowledge all',
    map_block_expired_title: 'Subscription expired',
    map_block_expired_body: 'Tracking for this device has been suspended. Please renew your subscription.',
    map_block_no_credits_title: 'Position credits exhausted',
    expiry_warning_title: 'Subscription expiring soon',
    expiry_warning_body: (days: number) => `This device's subscription expires in ${days} day${days > 1 ? 's' : ''}. Please renew it to avoid any interruption in tracking.`,
    expiry_warning_dismiss: 'Continue anyway',
    map_block_no_credits_body: 'This device has no remaining position credits. Please purchase more credits.',
    last_gps_fix: 'Last GPS Fix',
    last_comm: 'Last communication',
    positions: 'positions',
    today: 'today',
    share: 'Share',
    share_position_msg: 'Here is the location of tracker {name} as of {datetime}: {link}',
    last_command: 'Last command',
    battery: 'Battery',
    speed: 'Speed',
    location_title: 'Location',
    latitude: 'Latitude',
    longitude: 'Longitude',
    address: 'Address',
    photo_edit: 'Edit',
    photo_add: 'Upload your photo',
    history_title: 'History',
    history_start: 'Start',
    history_end: 'End',
    history_load: 'Load history',
    history_type_position: 'Position',
    history_type_start: 'Start',
    history_type_stop: 'Stop',
    history_type_power_up: 'Power up',
    history_type_power_down: 'Power down',
    history_type_charging: 'On charge',
    history_type_off_charge: 'Off charge',
    history_type_checkin: 'Check-in',
    history_type_door_open: 'Door open',
    history_type_door_closed: 'Door closed',
    history_type_fence_enter: 'Entered zone',
    history_type_fence_leave: 'Left zone',
    history_delete: 'Delete history',
    history_delete_confirm_title: 'Delete history',
    history_delete_confirm_body: 'Are you sure you want to delete this device\'s history? This action cannot be undone.',
    history_delete_confirm_btn: 'Delete',
    history_loading: 'Loading…',
    history_points: 'points',
    history_error_empty: 'No GPS points for this period.',
    history_error_load: 'Error loading history.',
    api_error: 'Unable to load data. Check your connection.',
    admin_login_error: 'Unable to sign in to this account. Try another one.',
    admin_search: 'Search account…',
    admin_no_results: 'No results',
    admin_searching: 'Searching…',
    today_positions: 'positions today',
    period_positions: 'positions (period)',
    history_filter_events: 'Starts / Stops only',
    history_filter_door_events: 'Door events only',
    history_filter_fence_events: 'Enter / Leave fence only',
    history_trips: 'Trips mode',
    history_trip: 'Trip',
    history_parked: 'Parked',
    history_no_trips: 'No trips detected',
    today_distance: 'km today',
    period_distance: 'km (period)',
    clustering: 'Clustering',
    share_btn: 'Share',
    share_title: 'Share history',
    share_sub: 'An email with Excel and PDF attachments will be sent to the address below.',
    share_context: 'points · ',
    share_email_label: 'Email address',
    share_email_placeholder: 'example@domain.com',
    share_send: 'Send',
    share_sending: 'Sending…',
    share_success: 'Email sent successfully!',
    share_error: 'Failed to send. Please try again.',
    share_cancel: 'Cancel',
    gf_btn: 'Zones',
    gf_hint: 'Click on the map to place the zone',
    gf_hint_polygon: 'Click on the map to add points',
    gf_shape_circle: 'Circle',
    gf_shape_polygon: 'Polygon',
    gf_vertices: 'points',
    gf_radius: 'Radius',
    gf_cancel: 'Cancel',
    gf_save: 'Save',
    gf_modal_title: 'Save zone',
    gf_edit_title: 'Edit zone',
    gf_modal_name_label: 'Zone name',
    gf_modal_name_placeholder: 'E.g. North Warehouse',
    gf_modal_devices_label: 'Assigned devices',
    gf_modal_select_all: 'All devices',
    gf_modal_confirm: 'Confirm',
    gf_modal_cancel: 'Cancel',
    gf_info_radius: 'Radius',
    gf_info_devices: 'device(s)',
    gf_info_no_devices: 'No devices assigned',
    gf_info_edit: 'Edit',
    gf_info_delete: 'Delete',
    gf_save_error: 'Error saving zone. Please try again.',
    gf_ble_blocked_polygon: 'BLE devices cannot be assigned to a polygon zone.',
    gf_ble_blocked_radius: 'BLE devices cannot be assigned to a circular zone with a radius smaller than 800m.',
    gf_list_title: 'Geofences',
    gf_list_empty: 'No zones created',
    gf_delete_confirm_title: 'Delete zone?',
    gf_delete_confirm_body: 'This action cannot be undone.',
    gf_delete_confirm_btn: 'Delete',
    cmd_title: 'Commands',
    cmd_interval_label: 'Reporting Interval',
    cmd_send: 'Send',
    cmd_sending: 'Sending…',
    cmd_success: 'Command transmitted',
    cmd_gprs_info: 'The command will be applied at the next device STOP via GPRS.',
    cmd_cooldown: 'Next send in',
    cmd_error: 'Error sending command',
    cmd_no_credits: 'Insufficient SMS credits to send this command.',
    cmd_password_required: 'Password required',
    routing_duration: 'Duration',
    routing_distance: 'Distance',
    routing_arrival: 'Arrival',
    routing_picker_title: 'Open with',
    routing_inapp: 'Built-in navigation',
    routing_waze: 'Waze',
    routing_gmaps: 'Google Maps',
    routing_cancel: 'Cancel',
  },
  map: {
    global_view: 'Global View',
    total_tags: 'Total tags',
    selected_tag: 'Selected tag',
    position: 'Position',
    zone: 'Zone',
    battery: 'Battery',
    last_report: 'Last report',
    position_type: 'Position type',
    recent_history: 'Recent history',
    filter_all: 'All',
    filter_online: 'Online',
    filter_warning: 'Alerts',
    filter_palette: 'Pallets',
    filter_asset: 'Assets',
  },
  accounts: {
    title: 'Account Management',
    total: 'accounts',
    create: 'Create account',
    search: 'Search an account or device…',
    col_name: 'Name',
    col_devices: 'Devices',
    action_rename: 'Rename',
    action_password: 'Change password',
    action_delete: 'Delete',
    action_move: 'Move devices',
    modal_create_title: 'Create account',
    modal_create_name: 'Account name',
    modal_create_login: 'Login',
    modal_create_pwd: 'Password',
    modal_create_confirm: 'Confirm password',
    modal_create_btn: 'Create',
    modal_rename_title: 'Rename account',
    modal_rename_label: 'New name',
    modal_rename_btn: 'Rename',
    modal_pwd_title: 'Change password',
    modal_pwd_new: 'New password',
    modal_pwd_confirm: 'Confirm',
    modal_pwd_btn: 'Save',
    modal_delete_title: 'Delete account',
    modal_delete_msg: 'Are you sure you want to delete the account',
    modal_delete_warning: 'This action is irreversible.',
    modal_delete_devices_warning: (count: number) => `This account contains ${count} device${count > 1 ? 's' : ''}. ${count > 1 ? 'They' : 'It'} will be permanently deleted.`,
    modal_delete_confirm_label: 'I confirm the deletion of associated devices',
    modal_delete_btn: 'Delete',
    modal_move_title: 'Move devices',
    modal_move_dest: 'Destination account',
    modal_move_no_dest: '— Select an account —',
    modal_move_devices: 'Devices to move',
    modal_move_btn: 'Move',
    modal_move_empty: 'No devices in this account',
    cancel: 'Cancel',
    pwd_mismatch: 'Passwords do not match',
    pwd_error: 'Failed to update password',
    pwd_success: 'Password updated successfully',
    rename_error: 'Failed to rename account',
    rename_success: 'Account renamed successfully',
    create_error: 'Failed to create account',
    move_error: 'Failed to move devices',
    move_success: 'Devices moved successfully',
    create_error_duplicate: 'An account with this name already exists',
    create_success: 'Account created successfully',
    delete_error: 'Failed to delete account',
    delete_success: 'Account deleted successfully',
    no_accounts: 'No accounts found',
    select_account: 'Select an account to see its devices',
    notes_placeholder: 'Notes…',
    notes_save: 'Save',
    notes_success: 'Notes saved',
    commands_success: 'Setting updated',
    notes_error: 'Failed to save notes',
    commands_error: 'Failed to update setting',
    commands_label: 'Command access',
  },
  device_settings: {
    title: 'Device settings',
    section_name: 'Device name',
    name_label: 'Name',
    name_placeholder: 'Device name',
    section_contacts: 'Alert contacts',
    contact_label: 'Contact',
    type_email: 'Email',
    type_phone: 'Phone',
    placeholder_email: 'example@domain.com',
    placeholder_phone: '+44 7XXX XXX XXX',
    alert_geofence: 'Geofence',
    alert_motion: 'Motion',
    alert_low_battery: 'Low battery',
    section_battery: 'Low battery threshold',
    battery_threshold: 'Threshold',
    section_auto_arm: 'Auto Arm',
    auto_arm_info: 'Enables motion detection on a weekly schedule. For each day, set a time range during which the alarm is armed. Check "Outside hours" to invert the range: the alarm will be active outside the defined hours.',
    auto_arm_toggle: 'Enable scheduled motion detection',
    auto_arm_from: 'From',
    auto_arm_to: 'To',
    auto_arm_outside: 'Outside hours',
    save: 'Save',
    saved: 'Settings saved!',
  },
  settings: {
    title: 'Settings',
    section_account: 'Account',
    account_name_label: 'Account name',
    account_name_placeholder: 'Your name',
    section_security: 'Security',
    current_pwd: 'Current password',
    new_pwd: 'New password',
    confirm_pwd: 'Confirm password',
    pwd_mismatch: 'Passwords do not match.',
    pwd_wrong_current: 'Current password is incorrect.',
    pwd_changed: 'Password updated.',
    section_preferences: 'Preferences',
    date_format_label: 'Date format',
    date_dmy: 'DD/MM/YYYY',
    date_mdy: 'MM/DD/YYYY',
    distance_label: 'Distance unit',
    unit_km: 'Kilometers',
    unit_miles: 'Miles',
    section_language: 'Language',
    lang_fr: 'Français',
    lang_en: 'English',
    lang_it: 'Italiano',
    lang_es: 'Español',
    lang_nl: 'Nederlands',
    lang_de: 'Deutsch',
    save: 'Save',
    saved: 'Saved!',
    name_error: 'Update failed. Please try again.',
    section_push: 'Push Notifications',
    push_types: {
      motion: 'Motion Start Alert',
      sos: 'SOS/Panic Alert',
      power: 'Battery Low',
      fence: 'Fence Alerts',
    },
  },
  logs: {
    modal_title: 'Logs',
    type_alerts: 'Alert logs',
    type_commands: 'Command logs',
    date_from: 'From',
    date_to: 'To',
    load_btn: 'Load',
    loading: 'Loading…',
    no_device: 'Select a device to view its logs.',
    no_data: 'No data for this period.',
    col_date: 'Date',
    col_sent_time: 'Sent time',
    col_device: 'Device',
    col_recipient: 'Recipient',
    col_command: 'Command',
    col_status: 'Status',
    col_send_time: 'Send time',
    col_delivered_time: 'Delivered time',
    col_ack_time: 'Ack time',
    col_channel: 'Channel',
    status_sent: 'Sent',
    status_delivered: 'Delivered',
    status_acked: 'Acknowledged',
    status_pending: 'Pending',
    col_message: 'Message',
    error: 'Error loading logs.',
    share_placeholder: 'Send by email…',
    share_btn: 'Send',
    share_sending: 'Sending…',
    share_sent: 'Email sent!',
    share_error: 'Error sending email.',
  },
};

export const it: Translations = {
  common: {
    online: 'Online',
    alert: 'Allarme',
    low_battery: 'Batteria scarica',
    offline: 'Offline',
    loading: 'Caricamento…',
    ble_devices: 'Dispositivi BLE',
  },
  login: {
    tagline: 'Logistics OS',
    welcome: 'Accedi al tuo portale di gestione',
    username_label: 'Utente',
    username_placeholder: 'Nome utente',
    password_label: 'Password',
    submit: 'Accedi',
    submitting: 'Accesso in corso…',
    remember_me: 'Ricordami',
    error_credentials: 'Credenziali non valide. Riprova.',
    error_network: 'Impossibile raggiungere il server. Controlla la connessione.',
    error_prefix: 'Errore',
    saved_accounts: 'Account salvati',
    use_another_account: 'Usa un altro account',
    add_account: 'Aggiungi un account',
    user_manual: "Manuale d'uso",
  },
  nav: {
    nav_section: 'Navigazione',
    system_section: 'Impostazioni',
    dashboard: 'Dashboard',
    map: 'Mappa Globale',
    accounts: 'Account',
    dmc: 'DMC',
    logs: 'Log',
    settings: 'Account',
    device: 'Dispositivo',
    administrator: 'Amministratore',
    user_fallback: 'Utente',
    logout: 'Disconnetti',
    ble_finder: 'BLE Finder',
    support: 'Supporto',
  },
  support: {
    title: 'Supporto tecnico',
    subtitle: 'Invia la tua richiesta al nostro team, ti risponderemo via email.',
    device_label: 'Dispositivo',
    category_label: 'Categoria',
    back_dashboard: 'Torna alla dashboard',
    cat_technical: 'Problema tecnico',
    cat_account: 'Account',
    cat_billing: 'Fatturazione',
    cat_other: 'Altro',
    subject_label: 'Oggetto',
    subject_placeholder: 'Riepilogo della richiesta',
    message_label: 'Messaggio',
    message_placeholder: 'Descrivi il tuo problema o la tua domanda…',
    email_label: 'Indirizzo email',
    email_placeholder: 'tu@esempio.com',
    email_invalid: 'Inserisci un indirizzo email valido',
    reply_note: 'Risposta inviata a:',
    submit: 'Invia richiesta',
    sending: 'Invio…',
    success: 'La tua richiesta è stata inviata. Il nostro team ti risponderà a breve.',
    error: 'Invio della richiesta non riuscito. Riprova.',
  },
  ble: {
    title: 'BLE Finder',
    scan: 'Avvia scansione',
    stop: 'Ferma scansione',
    scanning: 'Scansione in corso…',
    devices_found: 'dispositivo/i trovato/i',
    empty: 'Nessun dispositivo rilevato',
    empty_hint: 'Avvia una scansione per scoprire i dispositivi BLE nelle vicinanze.',
    unknown_device: 'Dispositivo sconosciuto',
    err_unsupported: 'La scansione BLE è disponibile solo nell\'app mobile.',
    err_disabled: 'Attiva il Bluetooth per avviare una scansione.',
    err_permission: 'Autorizzazione Bluetooth negata. Consenti l\'accesso nelle impostazioni.',
    err_generic: 'Si è verificato un errore durante la scansione.',
    prox_near: 'Sei vicino',
    prox_medium: 'Distanza media',
    prox_far: 'Sei lontano',
    prox_hint: 'Spostati per regolare la prossimità.',
    signal_lost: 'Segnale perso',
    rename: 'Rinomina',
    rename_placeholder: 'Nome personalizzato',
    rename_save: 'Salva',
    rename_cancel: 'Annulla',
    rename_reset: 'Reimposta',
    expert_mode: 'Modalità Esperto',
    expert_hint: 'Filtro disattivato — tutti i dispositivi BLE',
    expert_exit: 'Esci',
    sound_on: 'Attiva suono',
    sound_off: 'Disattiva suono',
  },
  topbar: {
    alerts: 'Allarmi',
    settings: 'Impostazioni',
    dashboard_title: 'Dashboard',
    dashboard_sub: 'Gestione dispositivi in tempo reale',
    map_title: 'Mappa Globale',
    map_sub: 'Tutti i tag BLE sulla mappa',
    accounts_title: 'Gestione Account',
    accounts_sub: 'Creazione, modifica ed eliminazione di account',
    dmc_title: 'Device Management Console',
    dmc_sub: 'Panoramica e gestione di tutti i dispositivi',
    device_search: 'Cerca un dispositivo…',
  },
  dmc: {
    col_device: 'Nome',
    col_status: 'Stato',
    col_battery: 'Batteria',
    col_speed: 'Velocità',
    col_gps_fix: 'Ultimo Fix GPS',
    col_last_comm: 'Ultima comm.',
    col_expiry: 'Scadenza',
    col_coords: 'Coordinate',
    no_expiry: '—',
    no_fix: '—',
    comm_warning: 'Nessuna comunicazione da oltre 24 ore nonostante la batteria sia sufficiente. Il dispositivo potrebbe avere un problema. Prova a riavviarlo o contatta il supporto tecnico.',
    email_btn: 'Invia per email',
    email_title: 'Invia rapporto DMC',
    email_sub: 'Il rapporto verrà inviato come allegato PDF.',
    email_label: 'Indirizzo email',
    email_placeholder: 'destinatario@esempio.com',
    email_send: 'Invia',
    email_sending: 'Invio in corso…',
    email_cancel: 'Annulla',
    email_success: 'Rapporto inviato con successo.',
    email_error: 'Invio fallito. Riprova.',
  },
  dashboard: {
    loading: 'Caricamento…',
    panel_title: 'Dispositivi',
    active_suffix: 'attivi',
    search_placeholder: 'Nome o IMEI…',
    show_selected_only: 'Mostra solo questo dispositivo',
    overview: 'Panoramica',
    toggle_satellite: 'Passa a satellite / mappa',
    fab_close: 'Chiudi',
    info_title: 'Informazioni',
    imei: 'IMEI',
    position_type: 'Tipo di posizione',
    device_status: 'Stato',
    status_offline: 'Offline',
    status_sleeping: 'In standby',
    status_moving: 'In movimento',
    status_on: 'Acceso',
    status_door_open: 'Aperto',
    status_door_closed: 'Chiuso',
    tl_red: 'Rosso',
    tl_green: 'Verde',
    tl_off: 'Spento',
    motion_alarm_active: 'Rilevamento mov. attivato',
    motion_arm: 'Attiva rilevamento',
    motion_disarm: 'Disattiva rilevamento',
    sub_expiry: 'Abbonamento',
    sub_sms_credits: 'Crediti SMS',
    sub_pos_credits: 'Crediti posizione',
    alert_panel_title: 'Allarmi attivi',
    alert_ack: 'Conferma',
    alert_ack_all: 'Conferma tutti',
    map_block_expired_title: 'Abbonamento scaduto',
    map_block_expired_body: 'Il tracciamento di questo dispositivo è sospeso. Rinnova il tuo abbonamento.',
    map_block_no_credits_title: 'Crediti posizione esauriti',
    map_block_no_credits_body: 'Questo dispositivo non ha più crediti posizione. Acquistane di nuovi.',
    expiry_warning_title: 'Abbonamento in scadenza',
    expiry_warning_body: (days: number) => `L'abbonamento di questo dispositivo scade tra ${days} giorno${days > 1 ? 'i' : ''}. Rinnova per evitare interruzioni del tracciamento.`,
    expiry_warning_dismiss: 'Continua comunque',
    last_gps_fix: 'Ultimo Fix GPS',
    last_comm: 'Ultima comunicazione',
    positions: 'posizioni',
    today: 'oggi',
    share: 'Condividi',
    share_position_msg: 'Ecco la posizione del tracker {name} del {datetime}: {link}',
    last_command: 'Ultimo comando',
    battery: 'Batteria',
    speed: 'Velocità',
    location_title: 'Posizione',
    latitude: 'Latitudine',
    longitude: 'Longitudine',
    address: 'Indirizzo',
    photo_edit: 'Modifica',
    photo_add: 'Carica la tua foto',
    history_title: 'Cronologia',
    history_start: 'Inizio',
    history_end: 'Fine',
    history_load: 'Carica cronologia',
    history_type_position: 'Posizione',
    history_type_start: 'Avvio',
    history_type_stop: 'Arresto',
    history_type_power_up: 'Accensione',
    history_type_power_down: 'Spegnimento',
    history_type_charging: 'In carica',
    history_type_off_charge: 'Scollegato dal caricatore',
    history_type_checkin: 'Check-in',
    history_type_door_open: 'Porta aperta',
    history_type_door_closed: 'Porta chiusa',
    history_type_fence_enter: 'Entrata in zona',
    history_type_fence_leave: 'Uscita da zona',
    history_delete: 'Elimina cronologia',
    history_delete_confirm_title: 'Elimina cronologia',
    history_delete_confirm_body: 'Sei sicuro di voler eliminare la cronologia di questo dispositivo? Questa azione è irreversibile.',
    history_delete_confirm_btn: 'Elimina',
    history_loading: 'Caricamento…',
    history_points: 'punti',
    history_error_empty: 'Nessun punto GPS per questo periodo.',
    history_error_load: 'Errore durante il caricamento della cronologia.',
    api_error: 'Impossibile caricare i dati. Controlla la connessione.',
    admin_login_error: 'Impossibile accedere a questo account. Prova un altro.',
    admin_search: 'Cerca account…',
    admin_no_results: 'Nessun risultato',
    admin_searching: 'Ricerca…',
    today_positions: 'posizioni oggi',
    period_positions: 'posizioni (periodo)',
    history_filter_events: 'Solo Avvii / Arresti',
    history_filter_door_events: 'Solo eventi porta',
    history_filter_fence_events: 'Solo Enter / Leave fence',
    history_trips: 'Modalità Percorsi',
    history_trip: 'Percorso',
    history_parked: 'Parcheggiato',
    history_no_trips: 'Nessun percorso rilevato',
    today_distance: 'km oggi',
    period_distance: 'km (periodo)',
    clustering: 'Clustering',
    share_btn: 'Condividi',
    share_title: 'Condividi cronologia',
    share_sub: "Verrà inviata un'email con allegati Excel e PDF all'indirizzo indicato.",
    share_context: 'punti · ',
    share_email_label: 'Indirizzo email',
    share_email_placeholder: 'esempio@dominio.com',
    share_send: 'Invia',
    share_sending: 'Invio in corso…',
    share_success: 'Email inviata con successo!',
    share_error: 'Invio fallito. Riprova.',
    share_cancel: 'Annulla',
    gf_btn: 'Zone',
    gf_hint: 'Clicca sulla mappa per posizionare la zona',
    gf_hint_polygon: 'Clicca sulla mappa per aggiungere punti',
    gf_shape_circle: 'Cerchio',
    gf_shape_polygon: 'Poligono',
    gf_vertices: 'punti',
    gf_radius: 'Raggio',
    gf_cancel: 'Annulla',
    gf_save: 'Salva',
    gf_modal_title: 'Salva zona',
    gf_edit_title: 'Modifica zona',
    gf_modal_name_label: 'Nome della zona',
    gf_modal_name_placeholder: 'Es. Magazzino Nord',
    gf_modal_devices_label: 'Dispositivi associati',
    gf_modal_select_all: 'Tutti i dispositivi',
    gf_modal_confirm: 'Conferma',
    gf_modal_cancel: 'Annulla',
    gf_info_radius: 'Raggio',
    gf_info_devices: 'dispositivo/i',
    gf_info_no_devices: 'Nessun dispositivo assegnato',
    gf_info_edit: 'Modifica',
    gf_info_delete: 'Elimina',
    gf_save_error: 'Errore durante il salvataggio. Riprova.',
    gf_ble_blocked_polygon: 'I dispositivi BLE non possono essere assegnati a una zona poligonale.',
    gf_ble_blocked_radius: 'I dispositivi BLE non possono essere assegnati a una zona circolare con raggio inferiore a 800m.',
    gf_list_title: 'Aree geografiche',
    gf_list_empty: 'Nessuna zona creata',
    gf_delete_confirm_title: 'Eliminare la zona?',
    gf_delete_confirm_body: 'Questa azione è irreversibile.',
    gf_delete_confirm_btn: 'Elimina',
    cmd_title: 'Comandi',
    cmd_interval_label: 'Intervallo di segnalazione',
    cmd_send: 'Invia',
    cmd_sending: 'Invio…',
    cmd_success: 'Comando trasmesso',
    cmd_gprs_info: 'Il comando verrà applicato al prossimo arresto del dispositivo via GPRS.',
    cmd_cooldown: 'Prossimo invio tra',
    cmd_error: "Errore durante l'invio",
    cmd_no_credits: 'Crediti SMS insufficienti per inviare questo comando.',
    cmd_password_required: 'Password richiesta',
    routing_duration: 'Durata',
    routing_distance: 'Distanza',
    routing_arrival: 'Arrivo',
    routing_picker_title: 'Apri con',
    routing_inapp: 'Navigazione integrata',
    routing_waze: 'Waze',
    routing_gmaps: 'Google Maps',
    routing_cancel: 'Annulla',
  },
  map: {
    global_view: 'Vista Globale',
    total_tags: 'Tag totali',
    selected_tag: 'Tag selezionato',
    position: 'Posizione',
    zone: 'Zona',
    battery: 'Batteria',
    last_report: 'Ultimo rapporto',
    position_type: 'Tipo di posizione',
    recent_history: 'Cronologia recente',
    filter_all: 'Tutti',
    filter_online: 'Online',
    filter_warning: 'Allarmi',
    filter_palette: 'Pallet',
    filter_asset: 'Asset',
  },
  accounts: {
    title: 'Gestione Account',
    total: 'account',
    create: 'Crea account',
    search: 'Cerca un account o dispositivo…',
    col_name: 'Nome',
    col_devices: 'Dispositivi',
    action_rename: 'Rinomina',
    action_password: 'Cambia password',
    action_delete: 'Elimina',
    action_move: 'Sposta dispositivi',
    modal_create_title: 'Crea account',
    modal_create_name: 'Nome account',
    modal_create_login: 'Login',
    modal_create_pwd: 'Password',
    modal_create_confirm: 'Conferma password',
    modal_create_btn: 'Crea',
    modal_rename_title: 'Rinomina account',
    modal_rename_label: 'Nuovo nome',
    modal_rename_btn: 'Rinomina',
    modal_pwd_title: 'Cambia password',
    modal_pwd_new: 'Nuova password',
    modal_pwd_confirm: 'Conferma',
    modal_pwd_btn: 'Salva',
    modal_delete_title: 'Elimina account',
    modal_delete_msg: "Sei sicuro di voler eliminare l'account",
    modal_delete_warning: 'Questa azione è irreversibile.',
    modal_delete_devices_warning: (count: number) => `Questo account contiene ${count} dispositiv${count > 1 ? 'i' : 'o'}. ${count > 1 ? 'Verranno' : 'Verrà'} eliminat${count > 1 ? 'i' : 'o'} definitivamente.`,
    modal_delete_confirm_label: "Confermo l'eliminazione dei dispositivi associati",
    modal_delete_btn: 'Elimina',
    modal_move_title: 'Sposta dispositivi',
    modal_move_dest: 'Account di destinazione',
    modal_move_no_dest: '— Seleziona un account —',
    modal_move_devices: 'Dispositivi da spostare',
    modal_move_btn: 'Sposta',
    modal_move_empty: 'Nessun dispositivo in questo account',
    cancel: 'Annulla',
    pwd_mismatch: 'Le password non corrispondono',
    pwd_error: 'Errore durante l\'aggiornamento della password',
    pwd_success: 'Password aggiornata con successo',
    rename_error: "Errore durante la rinomina dell'account",
    rename_success: 'Account rinominato con successo',
    create_error: "Errore durante la creazione dell'account",
    move_error: 'Errore durante lo spostamento dei dispositivi',
    move_success: 'Dispositivi spostati con successo',
    create_error_duplicate: 'Esiste già un account con questo nome',
    create_success: 'Account creato con successo',
    delete_error: "Errore durante l'eliminazione dell'account",
    delete_success: 'Account eliminato con successo',
    no_accounts: 'Nessun account trovato',
    select_account: 'Seleziona un account per vedere i suoi dispositivi',
    notes_placeholder: 'Note…',
    notes_save: 'Salva',
    notes_success: 'Note salvate',
    commands_success: 'Impostazione aggiornata',
    notes_error: 'Errore durante il salvataggio',
    commands_error: "Errore durante l'aggiornamento",
    commands_label: 'Accesso ai comandi',
  },
  device_settings: {
    title: 'Impostazioni dispositivo',
    section_name: 'Nome dispositivo',
    name_label: 'Nome',
    name_placeholder: 'Nome dispositivo',
    section_contacts: 'Contatti di allarme',
    contact_label: 'Contatto',
    type_email: 'Email',
    type_phone: 'Telefono',
    placeholder_email: 'esempio@dominio.com',
    placeholder_phone: '+39 3XX XXX XXXX',
    alert_geofence: 'Geofence',
    alert_motion: 'Movimento',
    alert_low_battery: 'Batteria scarica',
    section_battery: 'Soglia batteria scarica',
    battery_threshold: 'Soglia',
    section_auto_arm: 'Auto Arm',
    auto_arm_info: "Attiva il rilevamento del movimento secondo una pianificazione settimanale. Per ogni giorno, imposta un intervallo di tempo durante il quale l'allarme è armato. Seleziona \"Fuori orario\" per invertire l'intervallo: l'allarme sarà attivo fuori dall'orario definito.",
    auto_arm_toggle: 'Attiva rilevamento movimento pianificato',
    auto_arm_from: 'Dalle',
    auto_arm_to: 'Alle',
    auto_arm_outside: 'Fuori orario',
    save: 'Salva',
    saved: 'Impostazioni salvate!',
  },
  settings: {
    title: 'Impostazioni',
    section_account: 'Account',
    account_name_label: 'Nome account',
    account_name_placeholder: 'Il tuo nome',
    section_security: 'Sicurezza',
    current_pwd: 'Password attuale',
    new_pwd: 'Nuova password',
    confirm_pwd: 'Conferma password',
    pwd_mismatch: 'Le password non corrispondono.',
    pwd_wrong_current: 'La password attuale non è corretta.',
    pwd_changed: 'Password aggiornata.',
    section_preferences: 'Preferenze',
    date_format_label: 'Formato data',
    date_dmy: 'GG/MM/AAAA',
    date_mdy: 'MM/GG/AAAA',
    distance_label: 'Unità di distanza',
    unit_km: 'Chilometri',
    unit_miles: 'Miglia',
    section_language: 'Lingua',
    lang_fr: 'Français',
    lang_en: 'English',
    lang_it: 'Italiano',
    lang_es: 'Español',
    lang_nl: 'Nederlands',
    lang_de: 'Deutsch',
    save: 'Salva',
    saved: 'Salvato!',
    name_error: 'Aggiornamento fallito. Riprova.',
    section_push: 'Notifiche Push',
    push_types: {
      motion: 'Avviso di movimento',
      sos: 'Allarme SOS/Panico',
      power: 'Batteria scarica',
      fence: 'Avvisi di zona',
    },
  },
  logs: {
    modal_title: 'Log',
    type_alerts: 'Allarmi inviati',
    type_commands: 'Comandi inviati',
    date_from: 'Dal',
    date_to: 'Al',
    load_btn: 'Carica',
    loading: 'Caricamento…',
    no_device: 'Seleziona un dispositivo per visualizzare i suoi log.',
    no_data: 'Nessun dato per questo periodo.',
    col_date: 'Data',
    col_sent_time: 'Ora di invio',
    col_device: 'Dispositivo',
    col_recipient: 'Destinatario',
    col_command: 'Comando',
    col_status: 'Stato',
    col_send_time: 'Ora di invio',
    col_delivered_time: 'Ora di consegna',
    col_ack_time: 'Ora di conferma',
    col_channel: 'Canale',
    status_sent: 'Inviato',
    status_delivered: 'Consegnato',
    status_acked: 'Confermato',
    status_pending: 'In attesa',
    col_message: 'Messaggio',
    error: 'Errore durante il caricamento dei log.',
    share_placeholder: 'Invia per email…',
    share_btn: 'Invia',
    share_sending: 'Invio…',
    share_sent: 'Email inviata!',
    share_error: "Errore durante l'invio.",
  },
};

export const es: Translations = {
  common: {
    online: 'En línea',
    alert: 'Alerta',
    low_battery: 'Batería baja',
    offline: 'Desconectado',
    loading: 'Cargando…',
    ble_devices: 'Dispositivos BLE',
  },
  login: {
    tagline: 'Logistics OS',
    welcome: 'Accede a tu portal de gestión',
    username_label: 'Usuario',
    username_placeholder: 'Nombre de usuario',
    password_label: 'Contraseña',
    submit: 'Iniciar sesión',
    submitting: 'Iniciando sesión…',
    remember_me: 'Recuérdame',
    error_credentials: 'Credenciales incorrectas. Inténtalo de nuevo.',
    error_network: 'No se puede conectar al servidor. Comprueba tu conexión.',
    error_prefix: 'Error',
    saved_accounts: 'Cuentas guardadas',
    use_another_account: 'Usar otra cuenta',
    add_account: 'Añadir una cuenta',
    user_manual: 'Manual de uso',
  },
  nav: {
    nav_section: 'Navegación',
    system_section: 'Configuración',
    dashboard: 'Dashboard',
    map: 'Mapa Global',
    accounts: 'Cuentas',
    dmc: 'DMC',
    logs: 'Registros',
    settings: 'Cuenta',
    device: 'Dispositivo',
    administrator: 'Administrador',
    user_fallback: 'Usuario',
    logout: 'Cerrar sesión',
    ble_finder: 'BLE Finder',
    support: 'Soporte',
  },
  support: {
    title: 'Soporte técnico',
    subtitle: 'Envía tu solicitud a nuestro equipo, te responderemos por email.',
    device_label: 'Dispositivo',
    category_label: 'Categoría',
    back_dashboard: 'Volver al panel',
    cat_technical: 'Problema técnico',
    cat_account: 'Cuenta',
    cat_billing: 'Facturación',
    cat_other: 'Otro',
    subject_label: 'Asunto',
    subject_placeholder: 'Resumen de tu solicitud',
    message_label: 'Mensaje',
    message_placeholder: 'Describe tu problema o tu pregunta…',
    email_label: 'Correo electrónico',
    email_placeholder: 'tu@ejemplo.com',
    email_invalid: 'Introduce un correo electrónico válido',
    reply_note: 'Respuesta enviada a:',
    submit: 'Enviar solicitud',
    sending: 'Enviando…',
    success: 'Tu solicitud se ha enviado. Nuestro equipo te responderá en breve.',
    error: 'No se pudo enviar la solicitud. Inténtalo de nuevo.',
  },
  ble: {
    title: 'BLE Finder',
    scan: 'Iniciar escaneo',
    stop: 'Detener escaneo',
    scanning: 'Escaneando…',
    devices_found: 'dispositivo(s) encontrado(s)',
    empty: 'Ningún dispositivo detectado',
    empty_hint: 'Inicia un escaneo para descubrir los dispositivos BLE cercanos.',
    unknown_device: 'Dispositivo desconocido',
    err_unsupported: 'El escaneo BLE solo está disponible en la aplicación móvil.',
    err_disabled: 'Activa el Bluetooth para iniciar un escaneo.',
    err_permission: 'Permiso de Bluetooth denegado. Permite el acceso en los ajustes.',
    err_generic: 'Se ha producido un error durante el escaneo.',
    prox_near: 'Estás cerca',
    prox_medium: 'Distancia media',
    prox_far: 'Estás lejos',
    prox_hint: 'Muévete para ajustar la proximidad.',
    signal_lost: 'Señal perdida',
    rename: 'Renombrar',
    rename_placeholder: 'Nombre personalizado',
    rename_save: 'Guardar',
    rename_cancel: 'Cancelar',
    rename_reset: 'Restablecer',
    expert_mode: 'Modo Experto',
    expert_hint: 'Filtro desactivado — todos los dispositivos BLE',
    expert_exit: 'Salir',
    sound_on: 'Activar sonido',
    sound_off: 'Silenciar',
  },
  topbar: {
    alerts: 'Alertas',
    settings: 'Configuración',
    dashboard_title: 'Dashboard',
    dashboard_sub: 'Gestión de dispositivos en tiempo real',
    map_title: 'Mapa Global',
    map_sub: 'Todos los tags BLE en el mapa',
    accounts_title: 'Gestión de Cuentas',
    accounts_sub: 'Crear, editar y eliminar cuentas',
    dmc_title: 'Device Management Console',
    dmc_sub: 'Visión general y gestión de todos los dispositivos',
    device_search: 'Buscar un dispositivo…',
  },
  dmc: {
    col_device: 'Nombre',
    col_status: 'Estado',
    col_battery: 'Batería',
    col_speed: 'Velocidad',
    col_gps_fix: 'Último Fix GPS',
    col_last_comm: 'Última com.',
    col_expiry: 'Vencimiento',
    col_coords: 'Coordenadas',
    no_expiry: '—',
    no_fix: '—',
    comm_warning: 'Sin comunicación durante más de 24 horas a pesar de tener batería suficiente. El dispositivo probablemente tiene un problema. Intenta reiniciarlo o contacta con el soporte técnico.',
    email_btn: 'Enviar por email',
    email_title: 'Enviar informe DMC',
    email_sub: 'El informe se enviará como archivo adjunto PDF.',
    email_label: 'Dirección de email',
    email_placeholder: 'destinatario@ejemplo.com',
    email_send: 'Enviar',
    email_sending: 'Enviando…',
    email_cancel: 'Cancelar',
    email_success: 'Informe enviado correctamente.',
    email_error: 'Error al enviar. Inténtalo de nuevo.',
  },
  dashboard: {
    loading: 'Cargando…',
    panel_title: 'Dispositivos',
    active_suffix: 'activos',
    search_placeholder: 'Nombre o IMEI…',
    show_selected_only: 'Mostrar solo este dispositivo',
    overview: 'Resumen',
    toggle_satellite: 'Cambiar a satélite / mapa',
    fab_close: 'Cerrar',
    info_title: 'Información',
    imei: 'IMEI',
    position_type: 'Tipo de posición',
    device_status: 'Estado',
    status_offline: 'Desconectado',
    status_sleeping: 'En espera',
    status_moving: 'En movimiento',
    status_on: 'Encendido',
    status_door_open: 'Abierto',
    status_door_closed: 'Cerrado',
    tl_red: 'Rojo',
    tl_green: 'Verde',
    tl_off: 'Apagado',
    motion_alarm_active: 'Detección de mov. activada',
    motion_arm: 'Activar detección',
    motion_disarm: 'Desactivar detección',
    sub_expiry: 'Suscripción',
    sub_sms_credits: 'Créditos SMS',
    sub_pos_credits: 'Créditos de posición',
    alert_panel_title: 'Alertas activas',
    alert_ack: 'Confirmar',
    alert_ack_all: 'Confirmar todas',
    map_block_expired_title: 'Suscripción vencida',
    map_block_expired_body: 'El seguimiento de este dispositivo está suspendido. Renueva tu suscripción.',
    map_block_no_credits_title: 'Créditos de posición agotados',
    map_block_no_credits_body: 'Este dispositivo no tiene más créditos de posición. Adquiere nuevos.',
    expiry_warning_title: 'Suscripción próxima a vencer',
    expiry_warning_body: (days: number) => `La suscripción de este dispositivo vence en ${days} día${days > 1 ? 's' : ''}. Renuévala para evitar interrupciones en el seguimiento.`,
    expiry_warning_dismiss: 'Continuar de todos modos',
    last_gps_fix: 'Último Fix GPS',
    last_comm: 'Última comunicación',
    positions: 'posiciones',
    today: 'hoy',
    share: 'Compartir',
    share_position_msg: 'Aquí está la ubicación del rastreador {name} con fecha {datetime}: {link}',
    last_command: 'Último comando',
    battery: 'Batería',
    speed: 'Velocidad',
    location_title: 'Ubicación',
    latitude: 'Latitud',
    longitude: 'Longitud',
    address: 'Dirección',
    photo_edit: 'Editar',
    photo_add: 'Sube tu foto',
    history_title: 'Historial',
    history_start: 'Inicio',
    history_end: 'Fin',
    history_load: 'Cargar historial',
    history_type_position: 'Posición',
    history_type_start: 'Inicio',
    history_type_stop: 'Parada',
    history_type_power_up: 'Encendido',
    history_type_power_down: 'Apagado',
    history_type_charging: 'Cargando',
    history_type_off_charge: 'Desconectado del cargador',
    history_type_checkin: 'Check-in',
    history_type_door_open: 'Puerta abierta',
    history_type_door_closed: 'Puerta cerrada',
    history_type_fence_enter: 'Entrada en zona',
    history_type_fence_leave: 'Salida de zona',
    history_delete: 'Eliminar historial',
    history_delete_confirm_title: 'Eliminar historial',
    history_delete_confirm_body: '¿Estás seguro de que quieres eliminar el historial de este dispositivo? Esta acción es irreversible.',
    history_delete_confirm_btn: 'Eliminar',
    history_loading: 'Cargando…',
    history_points: 'puntos',
    history_error_empty: 'No hay puntos GPS para este período.',
    history_error_load: 'Error al cargar el historial.',
    api_error: 'No se pueden cargar los datos. Comprueba tu conexión.',
    admin_login_error: 'No se puede acceder a esta cuenta. Prueba con otra.',
    admin_search: 'Buscar cuenta…',
    admin_no_results: 'Sin resultados',
    admin_searching: 'Buscando…',
    today_positions: 'posiciones hoy',
    period_positions: 'posiciones (período)',
    history_filter_events: 'Solo Inicios / Paradas',
    history_filter_door_events: 'Solo eventos de puerta',
    history_filter_fence_events: 'Solo Enter / Leave fence',
    history_trips: 'Modo Viajes',
    history_trip: 'Viaje',
    history_parked: 'Aparcado',
    history_no_trips: 'No se detectaron viajes',
    today_distance: 'km hoy',
    period_distance: 'km (período)',
    clustering: 'Clustering',
    share_btn: 'Compartir',
    share_title: 'Compartir historial',
    share_sub: 'Se enviará un email con archivos adjuntos Excel y PDF a la dirección indicada.',
    share_context: 'puntos · ',
    share_email_label: 'Dirección de email',
    share_email_placeholder: 'ejemplo@dominio.com',
    share_send: 'Enviar',
    share_sending: 'Enviando…',
    share_success: '¡Email enviado correctamente!',
    share_error: 'Error al enviar. Inténtalo de nuevo.',
    share_cancel: 'Cancelar',
    gf_btn: 'Zonas',
    gf_hint: 'Haz clic en el mapa para colocar la zona',
    gf_hint_polygon: 'Haz clic en el mapa para añadir puntos',
    gf_shape_circle: 'Círculo',
    gf_shape_polygon: 'Polígono',
    gf_vertices: 'puntos',
    gf_radius: 'Radio',
    gf_cancel: 'Cancelar',
    gf_save: 'Guardar',
    gf_modal_title: 'Guardar zona',
    gf_edit_title: 'Editar zona',
    gf_modal_name_label: 'Nombre de la zona',
    gf_modal_name_placeholder: 'Ej. Almacén Norte',
    gf_modal_devices_label: 'Dispositivos asignados',
    gf_modal_select_all: 'Todos los dispositivos',
    gf_modal_confirm: 'Confirmar',
    gf_modal_cancel: 'Cancelar',
    gf_info_radius: 'Radio',
    gf_info_devices: 'dispositivo(s)',
    gf_info_no_devices: 'Sin dispositivos asignados',
    gf_info_edit: 'Editar',
    gf_info_delete: 'Eliminar',
    gf_save_error: 'Error al guardar la zona. Inténtalo de nuevo.',
    gf_ble_blocked_polygon: 'Los dispositivos BLE no pueden asignarse a una zona poligonal.',
    gf_ble_blocked_radius: 'Los dispositivos BLE no pueden asignarse a una zona circular con radio inferior a 800m.',
    gf_list_title: 'Geocercas',
    gf_list_empty: 'No hay zonas creadas',
    gf_delete_confirm_title: '¿Eliminar la zona?',
    gf_delete_confirm_body: 'Esta acción es irreversible.',
    gf_delete_confirm_btn: 'Eliminar',
    cmd_title: 'Comandos',
    cmd_interval_label: 'Intervalo de reporte',
    cmd_send: 'Enviar',
    cmd_sending: 'Enviando…',
    cmd_success: 'Comando transmitido',
    cmd_gprs_info: 'El comando se aplicará en la próxima parada del dispositivo via GPRS.',
    cmd_cooldown: 'Próximo envío en',
    cmd_error: 'Error al enviar el comando',
    cmd_no_credits: 'Créditos SMS insuficientes para enviar este comando.',
    cmd_password_required: 'Contraseña requerida',
    routing_duration: 'Duración',
    routing_distance: 'Distancia',
    routing_arrival: 'Llegada',
    routing_picker_title: 'Abrir con',
    routing_inapp: 'Navegación integrada',
    routing_waze: 'Waze',
    routing_gmaps: 'Google Maps',
    routing_cancel: 'Cancelar',
  },
  map: {
    global_view: 'Vista Global',
    total_tags: 'Tags totales',
    selected_tag: 'Tag seleccionado',
    position: 'Posición',
    zone: 'Zona',
    battery: 'Batería',
    last_report: 'Último informe',
    position_type: 'Tipo de posición',
    recent_history: 'Historial reciente',
    filter_all: 'Todos',
    filter_online: 'En línea',
    filter_warning: 'Alertas',
    filter_palette: 'Paletas',
    filter_asset: 'Activos',
  },
  accounts: {
    title: 'Gestión de Cuentas',
    total: 'cuentas',
    create: 'Crear cuenta',
    search: 'Buscar una cuenta o dispositivo…',
    col_name: 'Nombre',
    col_devices: 'Dispositivos',
    action_rename: 'Renombrar',
    action_password: 'Cambiar contraseña',
    action_delete: 'Eliminar',
    action_move: 'Mover dispositivos',
    modal_create_title: 'Crear cuenta',
    modal_create_name: 'Nombre de cuenta',
    modal_create_login: 'Login',
    modal_create_pwd: 'Contraseña',
    modal_create_confirm: 'Confirmar contraseña',
    modal_create_btn: 'Crear',
    modal_rename_title: 'Renombrar cuenta',
    modal_rename_label: 'Nuevo nombre',
    modal_rename_btn: 'Renombrar',
    modal_pwd_title: 'Cambiar contraseña',
    modal_pwd_new: 'Nueva contraseña',
    modal_pwd_confirm: 'Confirmar',
    modal_pwd_btn: 'Guardar',
    modal_delete_title: 'Eliminar cuenta',
    modal_delete_msg: '¿Estás seguro de que quieres eliminar la cuenta',
    modal_delete_warning: 'Esta acción es irreversible.',
    modal_delete_devices_warning: (count: number) => `Esta cuenta contiene ${count} dispositivo${count > 1 ? 's' : ''}. ${count > 1 ? 'Se eliminarán' : 'Se eliminará'} de forma permanente.`,
    modal_delete_confirm_label: 'Confirmo la eliminación de los dispositivos asociados',
    modal_delete_btn: 'Eliminar',
    modal_move_title: 'Mover dispositivos',
    modal_move_dest: 'Cuenta de destino',
    modal_move_no_dest: '— Seleccionar una cuenta —',
    modal_move_devices: 'Dispositivos a mover',
    modal_move_btn: 'Mover',
    modal_move_empty: 'No hay dispositivos en esta cuenta',
    cancel: 'Cancelar',
    pwd_mismatch: 'Las contraseñas no coinciden',
    pwd_error: 'Error al actualizar la contraseña',
    pwd_success: 'Contraseña actualizada correctamente',
    rename_error: 'Error al renombrar la cuenta',
    rename_success: 'Cuenta renombrada correctamente',
    create_error: 'Error al crear la cuenta',
    move_error: 'Error al mover los dispositivos',
    move_success: 'Dispositivos movidos correctamente',
    create_error_duplicate: 'Ya existe una cuenta con este nombre',
    create_success: 'Cuenta creada correctamente',
    delete_error: 'Error al eliminar la cuenta',
    delete_success: 'Cuenta eliminada correctamente',
    no_accounts: 'No se encontraron cuentas',
    select_account: 'Selecciona una cuenta para ver sus dispositivos',
    notes_placeholder: 'Notas…',
    notes_save: 'Guardar',
    notes_success: 'Notas guardadas',
    commands_success: 'Configuración actualizada',
    notes_error: 'Error al guardar las notas',
    commands_error: 'Error al actualizar la configuración',
    commands_label: 'Acceso a comandos',
  },
  device_settings: {
    title: 'Configuración del dispositivo',
    section_name: 'Nombre del dispositivo',
    name_label: 'Nombre',
    name_placeholder: 'Nombre del dispositivo',
    section_contacts: 'Contactos de alerta',
    contact_label: 'Contacto',
    type_email: 'Email',
    type_phone: 'Teléfono',
    placeholder_email: 'ejemplo@dominio.com',
    placeholder_phone: '+34 6XX XXX XXX',
    alert_geofence: 'Geocerca',
    alert_motion: 'Movimiento',
    alert_low_battery: 'Batería baja',
    section_battery: 'Umbral de batería baja',
    battery_threshold: 'Umbral',
    section_auto_arm: 'Auto Arm',
    auto_arm_info: 'Activa la detección de movimiento según un horario semanal. Para cada día, define un intervalo de tiempo durante el cual la alarma está armada. Marca "Fuera de horario" para invertir el intervalo: la alarma estará activa fuera del horario definido.',
    auto_arm_toggle: 'Activar detección de movimiento programada',
    auto_arm_from: 'Desde',
    auto_arm_to: 'Hasta',
    auto_arm_outside: 'Fuera de horario',
    save: 'Guardar',
    saved: '¡Configuración guardada!',
  },
  settings: {
    title: 'Configuración',
    section_account: 'Cuenta',
    account_name_label: 'Nombre de cuenta',
    account_name_placeholder: 'Tu nombre',
    section_security: 'Seguridad',
    current_pwd: 'Contraseña actual',
    new_pwd: 'Nueva contraseña',
    confirm_pwd: 'Confirmar contraseña',
    pwd_mismatch: 'Las contraseñas no coinciden.',
    pwd_wrong_current: 'La contraseña actual es incorrecta.',
    pwd_changed: 'Contraseña actualizada.',
    section_preferences: 'Preferencias',
    date_format_label: 'Formato de fecha',
    date_dmy: 'DD/MM/AAAA',
    date_mdy: 'MM/DD/AAAA',
    distance_label: 'Unidad de distancia',
    unit_km: 'Kilómetros',
    unit_miles: 'Millas',
    section_language: 'Idioma',
    lang_fr: 'Français',
    lang_en: 'English',
    lang_it: 'Italiano',
    lang_es: 'Español',
    lang_nl: 'Nederlands',
    lang_de: 'Deutsch',
    save: 'Guardar',
    saved: '¡Guardado!',
    name_error: 'Error al actualizar. Inténtalo de nuevo.',
    section_push: 'Notificaciones Push',
    push_types: {
      motion: 'Alerta de movimiento',
      sos: 'Alerta SOS/Pánico',
      power: 'Batería baja',
      fence: 'Alertas de zona',
    },
  },
  logs: {
    modal_title: 'Registros',
    type_alerts: 'Alertas enviadas',
    type_commands: 'Comandos enviados',
    date_from: 'Desde',
    date_to: 'Hasta',
    load_btn: 'Cargar',
    loading: 'Cargando…',
    no_device: 'Selecciona un dispositivo para ver sus registros.',
    no_data: 'No hay datos para este período.',
    col_date: 'Fecha',
    col_sent_time: 'Hora de envío',
    col_device: 'Dispositivo',
    col_recipient: 'Destinatario',
    col_command: 'Comando',
    col_status: 'Estado',
    col_send_time: 'Hora de envío',
    col_delivered_time: 'Hora de entrega',
    col_ack_time: 'Hora de confirmación',
    col_channel: 'Canal',
    status_sent: 'Enviado',
    status_delivered: 'Entregado',
    status_acked: 'Confirmado',
    status_pending: 'Pendiente',
    col_message: 'Mensaje',
    error: 'Error al cargar los registros.',
    share_placeholder: 'Enviar por email…',
    share_btn: 'Enviar',
    share_sending: 'Enviando…',
    share_sent: '¡Email enviado!',
    share_error: 'Error al enviar el email.',
  },
};

export const nl: Translations = {
  common: {
    online: 'Online',
    alert: 'Alarm',
    low_battery: 'Lage batterij',
    offline: 'Offline',
    loading: 'Laden…',
    ble_devices: 'BLE-apparaten',
  },
  login: {
    tagline: 'Logistics OS',
    welcome: 'Aanmelden bij uw beheerdersportaal',
    username_label: 'Gebruiker',
    username_placeholder: 'Gebruikersnaam',
    password_label: 'Wachtwoord',
    submit: 'Aanmelden',
    submitting: 'Aanmelden…',
    remember_me: 'Onthoud mij',
    error_credentials: 'Ongeldige inloggegevens. Probeer opnieuw.',
    error_network: 'Kan de server niet bereiken. Controleer uw verbinding.',
    error_prefix: 'Fout',
    saved_accounts: 'Opgeslagen accounts',
    use_another_account: 'Een ander account gebruiken',
    add_account: 'Een account toevoegen',
    user_manual: 'Gebruikershandleiding',
  },
  nav: {
    nav_section: 'Navigatie',
    system_section: 'Instellingen',
    dashboard: 'Dashboard',
    map: 'Globale Kaart',
    accounts: 'Accounts',
    dmc: 'DMC',
    logs: 'Logs',
    settings: 'Account',
    device: 'Apparaat',
    administrator: 'Beheerder',
    user_fallback: 'Gebruiker',
    logout: 'Uitloggen',
    ble_finder: 'BLE Finder',
    support: 'Ondersteuning',
  },
  support: {
    title: 'Technische ondersteuning',
    subtitle: 'Stuur uw verzoek naar ons team, we reageren per e-mail.',
    device_label: 'Apparaat',
    category_label: 'Categorie',
    back_dashboard: 'Terug naar dashboard',
    cat_technical: 'Technisch probleem',
    cat_account: 'Account',
    cat_billing: 'Facturatie',
    cat_other: 'Overig',
    subject_label: 'Onderwerp',
    subject_placeholder: 'Samenvatting van uw verzoek',
    message_label: 'Bericht',
    message_placeholder: 'Beschrijf uw probleem of vraag…',
    email_label: 'E-mailadres',
    email_placeholder: 'jij@voorbeeld.com',
    email_invalid: 'Voer een geldig e-mailadres in',
    reply_note: 'Antwoord verzonden naar:',
    submit: 'Verzoek verzenden',
    sending: 'Verzenden…',
    success: 'Uw verzoek is verzonden. Ons team neemt spoedig contact op.',
    error: 'Verzenden van verzoek mislukt. Probeer het opnieuw.',
  },
  ble: {
    title: 'BLE Finder',
    scan: 'Scan starten',
    stop: 'Scan stoppen',
    scanning: 'Bezig met scannen…',
    devices_found: 'apparaat(en) gevonden',
    empty: 'Geen apparaat gedetecteerd',
    empty_hint: 'Start een scan om BLE-apparaten in de buurt te ontdekken.',
    unknown_device: 'Onbekend apparaat',
    err_unsupported: 'BLE-scannen is alleen beschikbaar in de mobiele app.',
    err_disabled: 'Schakel Bluetooth in om een scan te starten.',
    err_permission: 'Bluetooth-toestemming geweigerd. Sta toegang toe in de instellingen.',
    err_generic: 'Er is een fout opgetreden tijdens het scannen.',
    prox_near: 'U bent dichtbij',
    prox_medium: 'Gemiddelde afstand',
    prox_far: 'U bent ver weg',
    prox_hint: 'Beweeg om de nabijheid aan te passen.',
    signal_lost: 'Signaal verloren',
    rename: 'Hernoemen',
    rename_placeholder: 'Aangepaste naam',
    rename_save: 'Opslaan',
    rename_cancel: 'Annuleren',
    rename_reset: 'Herstellen',
    expert_mode: 'Expertmodus',
    expert_hint: 'Filter uit — alle BLE-apparaten',
    expert_exit: 'Sluiten',
    sound_on: 'Geluid aan',
    sound_off: 'Dempen',
  },
  topbar: {
    alerts: 'Alarmen',
    settings: 'Instellingen',
    dashboard_title: 'Dashboard',
    dashboard_sub: 'Apparaatbeheer in realtime',
    map_title: 'Globale Kaart',
    map_sub: 'Alle BLE-tags op de kaart',
    accounts_title: 'Accountbeheer',
    accounts_sub: 'Accounts aanmaken, bewerken en verwijderen',
    dmc_title: 'Device Management Console',
    dmc_sub: 'Overzicht en beheer van alle apparaten',
    device_search: 'Zoek een apparaat…',
  },
  dmc: {
    col_device: 'Naam',
    col_status: 'Status',
    col_battery: 'Batterij',
    col_speed: 'Snelheid',
    col_gps_fix: 'Laatste GPS Fix',
    col_last_comm: 'Laatste comm.',
    col_expiry: 'Vervaldatum',
    col_coords: 'Coördinaten',
    no_expiry: '—',
    no_fix: '—',
    comm_warning: 'Geen communicatie gedurende meer dan 24 uur ondanks voldoende batterij. Het apparaat heeft waarschijnlijk een probleem. Probeer het opnieuw op te starten of neem contact op met de technische ondersteuning.',
    email_btn: 'Verzenden per e-mail',
    email_title: 'DMC-rapport verzenden',
    email_sub: 'Het rapport wordt als PDF-bijlage verzonden.',
    email_label: 'E-mailadres',
    email_placeholder: 'ontvanger@voorbeeld.com',
    email_send: 'Verzenden',
    email_sending: 'Verzenden…',
    email_cancel: 'Annuleren',
    email_success: 'Rapport succesvol verzonden.',
    email_error: 'Verzenden mislukt. Probeer opnieuw.',
  },
  dashboard: {
    loading: 'Laden…',
    panel_title: 'Apparaten',
    active_suffix: 'actief',
    search_placeholder: 'Naam of IMEI…',
    show_selected_only: 'Alleen dit apparaat weergeven',
    overview: 'Overzicht',
    toggle_satellite: 'Wisselen naar satelliet / kaart',
    fab_close: 'Sluiten',
    info_title: 'Informatie',
    imei: 'IMEI',
    position_type: 'Positietype',
    device_status: 'Status',
    status_offline: 'Offline',
    status_sleeping: 'Slaapstand',
    status_moving: 'In beweging',
    status_on: 'Aan',
    status_door_open: 'Open',
    status_door_closed: 'Gesloten',
    tl_red: 'Rood',
    tl_green: 'Groen',
    tl_off: 'Uit',
    motion_alarm_active: 'Bewegingsdetectie ingeschakeld',
    motion_arm: 'Detectie inschakelen',
    motion_disarm: 'Detectie uitschakelen',
    sub_expiry: 'Abonnement',
    sub_sms_credits: 'SMS-credits',
    sub_pos_credits: 'Positiecredits',
    alert_panel_title: 'Actieve alarmen',
    alert_ack: 'Bevestigen',
    alert_ack_all: 'Alles bevestigen',
    map_block_expired_title: 'Abonnement verlopen',
    map_block_expired_body: 'De tracking van dit apparaat is opgeschort. Verleng uw abonnement.',
    map_block_no_credits_title: 'Positiecredits uitgeput',
    map_block_no_credits_body: 'Dit apparaat heeft geen positiecredits meer. Koop nieuwe credits.',
    expiry_warning_title: 'Abonnement verloopt binnenkort',
    expiry_warning_body: (days: number) => `Het abonnement van dit apparaat verloopt over ${days} dag${days > 1 ? 'en' : ''}. Verleng het om onderbrekingen in de tracking te voorkomen.`,
    expiry_warning_dismiss: 'Toch doorgaan',
    last_gps_fix: 'Laatste GPS Fix',
    last_comm: 'Laatste communicatie',
    positions: 'posities',
    today: 'vandaag',
    share: 'Delen',
    share_position_msg: 'Hier is de locatie van tracker {name} op {datetime}: {link}',
    last_command: 'Laatste commando',
    battery: 'Batterij',
    speed: 'Snelheid',
    location_title: 'Locatie',
    latitude: 'Breedtegraad',
    longitude: 'Lengtegraad',
    address: 'Adres',
    photo_edit: 'Bewerken',
    photo_add: 'Upload uw foto',
    history_title: 'Geschiedenis',
    history_start: 'Begin',
    history_end: 'Einde',
    history_load: 'Geschiedenis laden',
    history_type_position: 'Positie',
    history_type_start: 'Start',
    history_type_stop: 'Stop',
    history_type_power_up: 'Inschakelen',
    history_type_power_down: 'Uitschakelen',
    history_type_charging: 'Opladen',
    history_type_off_charge: 'Oplader losgekoppeld',
    history_type_checkin: 'Check-in',
    history_type_door_open: 'Deur open',
    history_type_door_closed: 'Deur gesloten',
    history_type_fence_enter: 'Zone betreden',
    history_type_fence_leave: 'Zone verlaten',
    history_delete: 'Geschiedenis verwijderen',
    history_delete_confirm_title: 'Geschiedenis verwijderen',
    history_delete_confirm_body: 'Weet u zeker dat u de geschiedenis van dit apparaat wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    history_delete_confirm_btn: 'Verwijderen',
    history_loading: 'Laden…',
    history_points: 'punten',
    history_error_empty: 'Geen GPS-punten voor deze periode.',
    history_error_load: 'Fout bij het laden van de geschiedenis.',
    api_error: 'Kan geen gegevens laden. Controleer uw verbinding.',
    admin_login_error: 'Kan niet aanmelden bij dit account. Probeer een ander.',
    admin_search: 'Account zoeken…',
    admin_no_results: 'Geen resultaten',
    admin_searching: 'Zoeken…',
    today_positions: 'posities vandaag',
    period_positions: 'posities (periode)',
    history_filter_events: 'Alleen Starts / Stops',
    history_filter_door_events: 'Alleen deurgebeurtenissen',
    history_filter_fence_events: 'Alleen Enter / Leave fence',
    history_trips: 'Rittenstand',
    history_trip: 'Rit',
    history_parked: 'Geparkeerd',
    history_no_trips: 'Geen ritten gedetecteerd',
    today_distance: 'km vandaag',
    period_distance: 'km (periode)',
    clustering: 'Clustering',
    share_btn: 'Delen',
    share_title: 'Geschiedenis delen',
    share_sub: 'Er wordt een e-mail verzonden met Excel- en PDF-bijlagen naar het opgegeven adres.',
    share_context: 'punten · ',
    share_email_label: 'E-mailadres',
    share_email_placeholder: 'voorbeeld@domein.com',
    share_send: 'Verzenden',
    share_sending: 'Verzenden…',
    share_success: 'E-mail succesvol verzonden!',
    share_error: 'Verzenden mislukt. Probeer opnieuw.',
    share_cancel: 'Annuleren',
    gf_btn: 'Zones',
    gf_hint: 'Klik op de kaart om de zone te plaatsen',
    gf_hint_polygon: 'Klik op de kaart om punten toe te voegen',
    gf_shape_circle: 'Cirkel',
    gf_shape_polygon: 'Veelhoek',
    gf_vertices: 'punten',
    gf_radius: 'Straal',
    gf_cancel: 'Annuleren',
    gf_save: 'Opslaan',
    gf_modal_title: 'Zone opslaan',
    gf_edit_title: 'Zone bewerken',
    gf_modal_name_label: 'Zonenaam',
    gf_modal_name_placeholder: 'Bijv. Noord Magazijn',
    gf_modal_devices_label: 'Toegewezen apparaten',
    gf_modal_select_all: 'Alle apparaten',
    gf_modal_confirm: 'Bevestigen',
    gf_modal_cancel: 'Annuleren',
    gf_info_radius: 'Straal',
    gf_info_devices: 'apparaat/apparaten',
    gf_info_no_devices: 'Geen apparaten toegewezen',
    gf_info_edit: 'Bewerken',
    gf_info_delete: 'Verwijderen',
    gf_save_error: 'Fout bij opslaan van zone. Probeer opnieuw.',
    gf_ble_blocked_polygon: 'BLE-apparaten kunnen niet worden toegewezen aan een veelhoekige zone.',
    gf_ble_blocked_radius: 'BLE-apparaten kunnen niet worden toegewezen aan een cirkelvormige zone met een straal van minder dan 800m.',
    gf_list_title: 'Geografische zones',
    gf_list_empty: 'Geen zones aangemaakt',
    gf_delete_confirm_title: 'Zone verwijderen?',
    gf_delete_confirm_body: 'Deze actie kan niet ongedaan worden gemaakt.',
    gf_delete_confirm_btn: 'Verwijderen',
    cmd_title: "Commando's",
    cmd_interval_label: 'Rapportage-interval',
    cmd_send: 'Verzenden',
    cmd_sending: 'Verzenden…',
    cmd_success: 'Commando verzonden',
    cmd_gprs_info: 'Het commando wordt toegepast bij de volgende stop van het apparaat via GPRS.',
    cmd_cooldown: 'Volgende verzending over',
    cmd_error: 'Fout bij verzenden van commando',
    cmd_no_credits: 'Onvoldoende SMS-credits om dit commando te verzenden.',
    cmd_password_required: 'Wachtwoord vereist',
    routing_duration: 'Duur',
    routing_distance: 'Afstand',
    routing_arrival: 'Aankomst',
    routing_picker_title: 'Openen met',
    routing_inapp: 'Ingebouwde navigatie',
    routing_waze: 'Waze',
    routing_gmaps: 'Google Maps',
    routing_cancel: 'Annuleren',
  },
  map: {
    global_view: 'Globaal Overzicht',
    total_tags: 'Totaal tags',
    selected_tag: 'Geselecteerde tag',
    position: 'Positie',
    zone: 'Zone',
    battery: 'Batterij',
    last_report: 'Laatste rapport',
    position_type: 'Positietype',
    recent_history: 'Recente geschiedenis',
    filter_all: 'Alle',
    filter_online: 'Online',
    filter_warning: 'Alarmen',
    filter_palette: 'Pallets',
    filter_asset: 'Activa',
  },
  accounts: {
    title: 'Accountbeheer',
    total: 'accounts',
    create: 'Account aanmaken',
    search: 'Zoek een account of apparaat…',
    col_name: 'Naam',
    col_devices: 'Apparaten',
    action_rename: 'Hernoemen',
    action_password: 'Wachtwoord wijzigen',
    action_delete: 'Verwijderen',
    action_move: 'Apparaten verplaatsen',
    modal_create_title: 'Account aanmaken',
    modal_create_name: 'Accountnaam',
    modal_create_login: 'Login',
    modal_create_pwd: 'Wachtwoord',
    modal_create_confirm: 'Wachtwoord bevestigen',
    modal_create_btn: 'Aanmaken',
    modal_rename_title: 'Account hernoemen',
    modal_rename_label: 'Nieuwe naam',
    modal_rename_btn: 'Hernoemen',
    modal_pwd_title: 'Wachtwoord wijzigen',
    modal_pwd_new: 'Nieuw wachtwoord',
    modal_pwd_confirm: 'Bevestigen',
    modal_pwd_btn: 'Opslaan',
    modal_delete_title: 'Account verwijderen',
    modal_delete_msg: 'Weet u zeker dat u het account wilt verwijderen',
    modal_delete_warning: 'Deze actie is onomkeerbaar.',
    modal_delete_devices_warning: (count: number) => `Dit account bevat ${count} apparaat${count > 1 ? 'en' : ''}. ${count > 1 ? 'Ze worden' : 'Het wordt'} definitief verwijderd.`,
    modal_delete_confirm_label: 'Ik bevestig de verwijdering van de gekoppelde apparaten',
    modal_delete_btn: 'Verwijderen',
    modal_move_title: 'Apparaten verplaatsen',
    modal_move_dest: 'Doelaccount',
    modal_move_no_dest: '— Selecteer een account —',
    modal_move_devices: 'Te verplaatsen apparaten',
    modal_move_btn: 'Verplaatsen',
    modal_move_empty: 'Geen apparaten in dit account',
    cancel: 'Annuleren',
    pwd_mismatch: 'Wachtwoorden komen niet overeen',
    pwd_error: 'Fout bij het bijwerken van het wachtwoord',
    pwd_success: 'Wachtwoord succesvol bijgewerkt',
    rename_error: 'Fout bij het hernoemen van het account',
    rename_success: 'Account succesvol hernoemd',
    create_error: 'Fout bij het aanmaken van het account',
    move_error: 'Fout bij het verplaatsen van apparaten',
    move_success: 'Apparaten succesvol verplaatst',
    create_error_duplicate: 'Er bestaat al een account met deze naam',
    create_success: 'Account succesvol aangemaakt',
    delete_error: 'Fout bij het verwijderen van het account',
    delete_success: 'Account succesvol verwijderd',
    no_accounts: 'Geen accounts gevonden',
    select_account: 'Selecteer een account om de apparaten te bekijken',
    notes_placeholder: 'Notities…',
    notes_save: 'Opslaan',
    notes_success: 'Notities opgeslagen',
    commands_success: 'Instelling bijgewerkt',
    notes_error: 'Fout bij opslaan van notities',
    commands_error: 'Fout bij bijwerken van instelling',
    commands_label: "Toegang tot commando's",
  },
  device_settings: {
    title: 'Apparaatinstellingen',
    section_name: 'Apparaatnaam',
    name_label: 'Naam',
    name_placeholder: 'Apparaatnaam',
    section_contacts: 'Alarmcontacten',
    contact_label: 'Contact',
    type_email: 'E-mail',
    type_phone: 'Telefoon',
    placeholder_email: 'voorbeeld@domein.com',
    placeholder_phone: '+31 6XX XXX XXXX',
    alert_geofence: 'Geofence',
    alert_motion: 'Beweging',
    alert_low_battery: 'Lage batterij',
    section_battery: 'Drempel lage batterij',
    battery_threshold: 'Drempel',
    section_auto_arm: 'Auto Arm',
    auto_arm_info: 'Schakelt bewegingsdetectie in op basis van een wekelijks schema. Stel voor elke dag een tijdsperiode in gedurende welke het alarm is ingeschakeld. Vink "Buiten uren" aan om de periode om te keren: het alarm is dan actief buiten de gedefinieerde uren.',
    auto_arm_toggle: 'Geplande bewegingsdetectie inschakelen',
    auto_arm_from: 'Van',
    auto_arm_to: 'Tot',
    auto_arm_outside: 'Buiten uren',
    save: 'Opslaan',
    saved: 'Instellingen opgeslagen!',
  },
  settings: {
    title: 'Instellingen',
    section_account: 'Account',
    account_name_label: 'Accountnaam',
    account_name_placeholder: 'Uw naam',
    section_security: 'Beveiliging',
    current_pwd: 'Huidig wachtwoord',
    new_pwd: 'Nieuw wachtwoord',
    confirm_pwd: 'Wachtwoord bevestigen',
    pwd_mismatch: 'Wachtwoorden komen niet overeen.',
    pwd_wrong_current: 'Huidig wachtwoord is onjuist.',
    pwd_changed: 'Wachtwoord bijgewerkt.',
    section_preferences: 'Voorkeuren',
    date_format_label: 'Datumnotatie',
    date_dmy: 'DD/MM/JJJJ',
    date_mdy: 'MM/DD/JJJJ',
    distance_label: 'Afstandseenheid',
    unit_km: 'Kilometers',
    unit_miles: 'Mijlen',
    section_language: 'Taal',
    lang_fr: 'Français',
    lang_en: 'English',
    lang_it: 'Italiano',
    lang_es: 'Español',
    lang_nl: 'Nederlands',
    lang_de: 'Deutsch',
    save: 'Opslaan',
    saved: 'Opgeslagen!',
    name_error: 'Bijwerken mislukt. Probeer opnieuw.',
    section_push: 'Pushmeldingen',
    push_types: {
      motion: 'Bewegingsalarm',
      sos: 'SOS/Paniekalarm',
      power: 'Batterij bijna leeg',
      fence: 'Zonemeldingen',
    },
  },
  logs: {
    modal_title: 'Logs',
    type_alerts: 'Verzonden alarmen',
    type_commands: "Verzonden commando's",
    date_from: 'Van',
    date_to: 'Tot',
    load_btn: 'Laden',
    loading: 'Laden…',
    no_device: 'Selecteer een apparaat om de logs te bekijken.',
    no_data: 'Geen gegevens voor deze periode.',
    col_date: 'Datum',
    col_sent_time: 'Verzendtijd',
    col_device: 'Apparaat',
    col_recipient: 'Ontvanger',
    col_command: 'Commando',
    col_status: 'Status',
    col_send_time: 'Verzendtijd',
    col_delivered_time: 'Bezorgingstijd',
    col_ack_time: 'Bevestigingstijd',
    col_channel: 'Kanaal',
    status_sent: 'Verzonden',
    status_delivered: 'Bezorgd',
    status_acked: 'Bevestigd',
    status_pending: 'In behandeling',
    col_message: 'Bericht',
    error: 'Fout bij het laden van logs.',
    share_placeholder: 'Verzenden per e-mail…',
    share_btn: 'Verzenden',
    share_sending: 'Verzenden…',
    share_sent: 'E-mail verzonden!',
    share_error: 'Fout bij het verzenden van e-mail.',
  },
};

export const de: Translations = {
  common: {
    online: 'Online',
    alert: 'Alarm',
    low_battery: 'Schwache Batterie',
    offline: 'Offline',
    loading: 'Laden…',
    ble_devices: 'BLE-Geräte',
  },
  login: {
    tagline: 'Logistics OS',
    welcome: 'Melden Sie sich bei Ihrem Verwaltungsportal an',
    username_label: 'Benutzer',
    username_placeholder: 'Benutzername',
    password_label: 'Passwort',
    submit: 'Anmelden',
    submitting: 'Anmeldung läuft…',
    remember_me: 'Angemeldet bleiben',
    error_credentials: 'Ungültige Anmeldedaten. Bitte versuchen Sie es erneut.',
    error_network: 'Server nicht erreichbar. Überprüfen Sie Ihre Verbindung.',
    error_prefix: 'Fehler',
    saved_accounts: 'Gespeicherte Konten',
    use_another_account: 'Anderes Konto verwenden',
    add_account: 'Konto hinzufügen',
    user_manual: 'Bedienungsanleitung',
  },
  nav: {
    nav_section: 'Navigation',
    system_section: 'Einstellungen',
    dashboard: 'Dashboard',
    map: 'Globale Karte',
    accounts: 'Konten',
    dmc: 'DMC',
    logs: 'Protokolle',
    settings: 'Konto',
    device: 'Gerät',
    administrator: 'Administrator',
    user_fallback: 'Benutzer',
    logout: 'Abmelden',
    ble_finder: 'BLE Finder',
    support: 'Support',
  },
  support: {
    title: 'Technischer Support',
    subtitle: 'Senden Sie Ihre Anfrage an unser Team, wir antworten per E-Mail.',
    device_label: 'Gerät',
    category_label: 'Kategorie',
    back_dashboard: 'Zurück zum Dashboard',
    cat_technical: 'Technisches Problem',
    cat_account: 'Konto',
    cat_billing: 'Abrechnung',
    cat_other: 'Sonstiges',
    subject_label: 'Betreff',
    subject_placeholder: 'Zusammenfassung Ihrer Anfrage',
    message_label: 'Nachricht',
    message_placeholder: 'Beschreiben Sie Ihr Problem oder Ihre Frage…',
    email_label: 'E-Mail-Adresse',
    email_placeholder: 'du@beispiel.com',
    email_invalid: 'Bitte gültige E-Mail-Adresse eingeben',
    reply_note: 'Antwort gesendet an:',
    submit: 'Anfrage senden',
    sending: 'Senden…',
    success: 'Ihre Anfrage wurde gesendet. Unser Team meldet sich in Kürze.',
    error: 'Senden der Anfrage fehlgeschlagen. Bitte erneut versuchen.',
  },
  ble: {
    title: 'BLE Finder',
    scan: 'Scan starten',
    stop: 'Scan stoppen',
    scanning: 'Scan läuft…',
    devices_found: 'Gerät(e) gefunden',
    empty: 'Kein Gerät erkannt',
    empty_hint: 'Starten Sie einen Scan, um BLE-Geräte in der Nähe zu finden.',
    unknown_device: 'Unbekanntes Gerät',
    err_unsupported: 'BLE-Scannen ist nur in der mobilen App verfügbar.',
    err_disabled: 'Bitte aktivieren Sie Bluetooth, um einen Scan zu starten.',
    err_permission: 'Bluetooth-Berechtigung verweigert. Erlauben Sie den Zugriff in den Einstellungen.',
    err_generic: 'Beim Scannen ist ein Fehler aufgetreten.',
    prox_near: 'Sie sind nah dran',
    prox_medium: 'Mittlere Entfernung',
    prox_far: 'Sie sind weit entfernt',
    prox_hint: 'Bewegen Sie sich, um die Nähe anzupassen.',
    signal_lost: 'Signal verloren',
    rename: 'Umbenennen',
    rename_placeholder: 'Eigener Name',
    rename_save: 'Speichern',
    rename_cancel: 'Abbrechen',
    rename_reset: 'Zurücksetzen',
    expert_mode: 'Expertenmodus',
    expert_hint: 'Filter aus — alle BLE-Geräte',
    expert_exit: 'Beenden',
    sound_on: 'Ton an',
    sound_off: 'Stummschalten',
  },
  topbar: {
    alerts: 'Alarme',
    settings: 'Einstellungen',
    dashboard_title: 'Dashboard',
    dashboard_sub: 'Geräteverwaltung in Echtzeit',
    map_title: 'Globale Karte',
    map_sub: 'Alle BLE-Tags auf der Karte',
    accounts_title: 'Kontoverwaltung',
    accounts_sub: 'Konten erstellen, bearbeiten und löschen',
    dmc_title: 'Device Management Console',
    dmc_sub: 'Übersicht und Verwaltung aller Geräte',
    device_search: 'Gerät suchen…',
  },
  dmc: {
    col_device: 'Name',
    col_status: 'Status',
    col_battery: 'Batterie',
    col_speed: 'Geschwindigkeit',
    col_gps_fix: 'Letzter GPS-Fix',
    col_last_comm: 'Letzte Komm.',
    col_expiry: 'Ablauf',
    col_coords: 'Koordinaten',
    no_expiry: '—',
    no_fix: '—',
    comm_warning: 'Keine Kommunikation seit mehr als 24 Stunden trotz ausreichender Batterie. Das Gerät hat wahrscheinlich ein Problem. Versuchen Sie, es neu zu starten, oder wenden Sie sich an den technischen Support.',
    email_btn: 'Per E-Mail senden',
    email_title: 'DMC-Bericht senden',
    email_sub: 'Der Bericht wird als PDF-Anhang gesendet.',
    email_label: 'E-Mail-Adresse',
    email_placeholder: 'empfaenger@beispiel.de',
    email_send: 'Senden',
    email_sending: 'Wird gesendet…',
    email_cancel: 'Abbrechen',
    email_success: 'Bericht erfolgreich gesendet.',
    email_error: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut.',
  },
  dashboard: {
    loading: 'Laden…',
    panel_title: 'Geräte',
    active_suffix: 'aktiv',
    search_placeholder: 'Name oder IMEI…',
    show_selected_only: 'Nur dieses Gerät anzeigen',
    overview: 'Übersicht',
    toggle_satellite: 'Zu Satellit / Karte wechseln',
    fab_close: 'Schließen',
    info_title: 'Informationen',
    imei: 'IMEI',
    position_type: 'Positionstyp',
    device_status: 'Status',
    status_offline: 'Offline',
    status_sleeping: 'Ruhezustand',
    status_moving: 'In Bewegung',
    status_on: 'Ein',
    status_door_open: 'Offen',
    status_door_closed: 'Geschlossen',
    tl_red: 'Rot',
    tl_green: 'Grün',
    tl_off: 'Aus',
    motion_alarm_active: 'Bewegungserkennung aktiviert',
    motion_arm: 'Erkennung aktivieren',
    motion_disarm: 'Erkennung deaktivieren',
    sub_expiry: 'Abonnement',
    sub_sms_credits: 'SMS-Guthaben',
    sub_pos_credits: 'Positionsguthaben',
    alert_panel_title: 'Aktive Alarme',
    alert_ack: 'Bestätigen',
    alert_ack_all: 'Alle bestätigen',
    map_block_expired_title: 'Abonnement abgelaufen',
    map_block_expired_body: 'Die Verfolgung dieses Geräts ist ausgesetzt. Bitte erneuern Sie Ihr Abonnement.',
    map_block_no_credits_title: 'Positionsguthaben erschöpft',
    map_block_no_credits_body: 'Dieses Gerät hat kein Positionsguthaben mehr. Bitte kaufen Sie neues Guthaben.',
    expiry_warning_title: 'Abonnement läuft bald ab',
    expiry_warning_body: (days: number) => `Das Abonnement dieses Geräts läuft in ${days} Tag${days > 1 ? 'en' : ''} ab. Bitte erneuern Sie es, um Unterbrechungen bei der Verfolgung zu vermeiden.`,
    expiry_warning_dismiss: 'Trotzdem fortfahren',
    last_gps_fix: 'Letzter GPS-Fix',
    last_comm: 'Letzte Kommunikation',
    positions: 'Positionen',
    today: 'heute',
    share: 'Teilen',
    share_position_msg: 'Hier ist die Position des Trackers {name} vom {datetime}: {link}',
    last_command: 'Letzter Befehl',
    battery: 'Batterie',
    speed: 'Geschwindigkeit',
    location_title: 'Standort',
    latitude: 'Breitengrad',
    longitude: 'Längengrad',
    address: 'Adresse',
    photo_edit: 'Bearbeiten',
    photo_add: 'Foto hochladen',
    history_title: 'Verlauf',
    history_start: 'Start',
    history_end: 'Ende',
    history_load: 'Verlauf laden',
    history_type_position: 'Position',
    history_type_start: 'Start',
    history_type_stop: 'Stopp',
    history_type_power_up: 'Einschalten',
    history_type_power_down: 'Ausschalten',
    history_type_charging: 'Wird geladen',
    history_type_off_charge: 'Ladegerät getrennt',
    history_type_checkin: 'Check-in',
    history_type_door_open: 'Tür geöffnet',
    history_type_door_closed: 'Tür geschlossen',
    history_type_fence_enter: 'Zone betreten',
    history_type_fence_leave: 'Zone verlassen',
    history_delete: 'Verlauf löschen',
    history_delete_confirm_title: 'Verlauf löschen',
    history_delete_confirm_body: 'Möchten Sie den Verlauf dieses Geräts wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    history_delete_confirm_btn: 'Löschen',
    history_loading: 'Laden…',
    history_points: 'Punkte',
    history_error_empty: 'Keine GPS-Punkte für diesen Zeitraum.',
    history_error_load: 'Fehler beim Laden des Verlaufs.',
    api_error: 'Daten können nicht geladen werden. Überprüfen Sie Ihre Verbindung.',
    admin_login_error: 'Anmeldung bei diesem Konto nicht möglich. Versuchen Sie ein anderes.',
    admin_search: 'Konto suchen…',
    admin_no_results: 'Keine Ergebnisse',
    admin_searching: 'Suche läuft…',
    today_positions: 'Positionen heute',
    period_positions: 'Positionen (Zeitraum)',
    history_filter_events: 'Nur Starts / Stopps',
    history_filter_door_events: 'Nur Türereignisse',
    history_filter_fence_events: 'Nur Enter / Leave fence',
    history_trips: 'Reisemodus',
    history_trip: 'Fahrt',
    history_parked: 'Geparkt',
    history_no_trips: 'Keine Fahrten erkannt',
    today_distance: 'km heute',
    period_distance: 'km (Zeitraum)',
    clustering: 'Clustering',
    share_btn: 'Teilen',
    share_title: 'Verlauf teilen',
    share_sub: 'Eine E-Mail mit Excel- und PDF-Anhängen wird an die angegebene Adresse gesendet.',
    share_context: 'Punkte · ',
    share_email_label: 'E-Mail-Adresse',
    share_email_placeholder: 'beispiel@domain.de',
    share_send: 'Senden',
    share_sending: 'Wird gesendet…',
    share_success: 'E-Mail erfolgreich gesendet!',
    share_error: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut.',
    share_cancel: 'Abbrechen',
    gf_btn: 'Zonen',
    gf_hint: 'Klicken Sie auf die Karte, um die Zone zu platzieren',
    gf_hint_polygon: 'Klicken Sie auf die Karte, um Punkte hinzuzufügen',
    gf_shape_circle: 'Kreis',
    gf_shape_polygon: 'Polygon',
    gf_vertices: 'Punkte',
    gf_radius: 'Radius',
    gf_cancel: 'Abbrechen',
    gf_save: 'Speichern',
    gf_modal_title: 'Zone speichern',
    gf_edit_title: 'Zone bearbeiten',
    gf_modal_name_label: 'Zonenname',
    gf_modal_name_placeholder: 'Z.B. Nordlager',
    gf_modal_devices_label: 'Zugewiesene Geräte',
    gf_modal_select_all: 'Alle Geräte',
    gf_modal_confirm: 'Bestätigen',
    gf_modal_cancel: 'Abbrechen',
    gf_info_radius: 'Radius',
    gf_info_devices: 'Gerät(e)',
    gf_info_no_devices: 'Keine Geräte zugewiesen',
    gf_info_edit: 'Bearbeiten',
    gf_info_delete: 'Löschen',
    gf_save_error: 'Fehler beim Speichern der Zone. Bitte versuchen Sie es erneut.',
    gf_ble_blocked_polygon: 'BLE-Geräte können keiner polygonalen Zone zugewiesen werden.',
    gf_ble_blocked_radius: 'BLE-Geräte können keiner kreisförmigen Zone mit einem Radius von weniger als 800m zugewiesen werden.',
    gf_list_title: 'Geofences',
    gf_list_empty: 'Keine Zonen erstellt',
    gf_delete_confirm_title: 'Zone löschen?',
    gf_delete_confirm_body: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    gf_delete_confirm_btn: 'Löschen',
    cmd_title: 'Befehle',
    cmd_interval_label: 'Berichtsintervall',
    cmd_send: 'Senden',
    cmd_sending: 'Wird gesendet…',
    cmd_success: 'Befehl übermittelt',
    cmd_gprs_info: 'Der Befehl wird beim nächsten Stopp des Geräts via GPRS angewendet.',
    cmd_cooldown: 'Nächste Sendung in',
    cmd_error: 'Fehler beim Senden des Befehls',
    cmd_no_credits: 'Nicht genügend SMS-Guthaben, um diesen Befehl zu senden.',
    cmd_password_required: 'Passwort erforderlich',
    routing_duration: 'Dauer',
    routing_distance: 'Entfernung',
    routing_arrival: 'Ankunft',
    routing_picker_title: 'Öffnen mit',
    routing_inapp: 'Integrierte Navigation',
    routing_waze: 'Waze',
    routing_gmaps: 'Google Maps',
    routing_cancel: 'Abbrechen',
  },
  map: {
    global_view: 'Globale Ansicht',
    total_tags: 'Gesamte Tags',
    selected_tag: 'Ausgewählter Tag',
    position: 'Position',
    zone: 'Zone',
    battery: 'Batterie',
    last_report: 'Letzter Bericht',
    position_type: 'Positionstyp',
    recent_history: 'Aktueller Verlauf',
    filter_all: 'Alle',
    filter_online: 'Online',
    filter_warning: 'Alarme',
    filter_palette: 'Paletten',
    filter_asset: 'Assets',
  },
  accounts: {
    title: 'Kontoverwaltung',
    total: 'Konten',
    create: 'Konto erstellen',
    search: 'Konto oder Gerät suchen…',
    col_name: 'Name',
    col_devices: 'Geräte',
    action_rename: 'Umbenennen',
    action_password: 'Passwort ändern',
    action_delete: 'Löschen',
    action_move: 'Geräte verschieben',
    modal_create_title: 'Konto erstellen',
    modal_create_name: 'Kontoname',
    modal_create_login: 'Login',
    modal_create_pwd: 'Passwort',
    modal_create_confirm: 'Passwort bestätigen',
    modal_create_btn: 'Erstellen',
    modal_rename_title: 'Konto umbenennen',
    modal_rename_label: 'Neuer Name',
    modal_rename_btn: 'Umbenennen',
    modal_pwd_title: 'Passwort ändern',
    modal_pwd_new: 'Neues Passwort',
    modal_pwd_confirm: 'Bestätigen',
    modal_pwd_btn: 'Speichern',
    modal_delete_title: 'Konto löschen',
    modal_delete_msg: 'Möchten Sie das Konto wirklich löschen',
    modal_delete_warning: 'Diese Aktion ist unumkehrbar.',
    modal_delete_devices_warning: (count: number) => `Dieses Konto enthält ${count} Gerät${count > 1 ? 'e' : ''}. ${count > 1 ? 'Sie werden' : 'Es wird'} dauerhaft gelöscht.`,
    modal_delete_confirm_label: 'Ich bestätige die Löschung der zugehörigen Geräte',
    modal_delete_btn: 'Löschen',
    modal_move_title: 'Geräte verschieben',
    modal_move_dest: 'Zielkonto',
    modal_move_no_dest: '— Konto auswählen —',
    modal_move_devices: 'Zu verschiebende Geräte',
    modal_move_btn: 'Verschieben',
    modal_move_empty: 'Keine Geräte in diesem Konto',
    cancel: 'Abbrechen',
    pwd_mismatch: 'Passwörter stimmen nicht überein',
    pwd_error: 'Fehler beim Aktualisieren des Passworts',
    pwd_success: 'Passwort erfolgreich aktualisiert',
    rename_error: 'Fehler beim Umbenennen des Kontos',
    rename_success: 'Konto erfolgreich umbenannt',
    create_error: 'Fehler beim Erstellen des Kontos',
    move_error: 'Fehler beim Verschieben der Geräte',
    move_success: 'Geräte erfolgreich verschoben',
    create_error_duplicate: 'Ein Konto mit diesem Namen existiert bereits',
    create_success: 'Konto erfolgreich erstellt',
    delete_error: 'Fehler beim Löschen des Kontos',
    delete_success: 'Konto erfolgreich gelöscht',
    no_accounts: 'Keine Konten gefunden',
    select_account: 'Wählen Sie ein Konto aus, um seine Geräte anzuzeigen',
    notes_placeholder: 'Notizen…',
    notes_save: 'Speichern',
    notes_success: 'Notizen gespeichert',
    commands_success: 'Einstellung aktualisiert',
    notes_error: 'Fehler beim Speichern der Notizen',
    commands_error: 'Fehler beim Aktualisieren der Einstellung',
    commands_label: 'Befehlszugang',
  },
  device_settings: {
    title: 'Geräteeinstellungen',
    section_name: 'Gerätename',
    name_label: 'Name',
    name_placeholder: 'Gerätename',
    section_contacts: 'Alarmkontakte',
    contact_label: 'Kontakt',
    type_email: 'E-Mail',
    type_phone: 'Telefon',
    placeholder_email: 'beispiel@domain.de',
    placeholder_phone: '+49 1XX XXXXXXXX',
    alert_geofence: 'Geofence',
    alert_motion: 'Bewegung',
    alert_low_battery: 'Schwache Batterie',
    section_battery: 'Schwellenwert schwache Batterie',
    battery_threshold: 'Schwellenwert',
    section_auto_arm: 'Auto Arm',
    auto_arm_info: 'Aktiviert die Bewegungserkennung gemäß einem wöchentlichen Zeitplan. Legen Sie für jeden Tag einen Zeitraum fest, in dem der Alarm aktiviert ist. Aktivieren Sie "Außerhalb der Zeiten", um den Zeitraum umzukehren: Der Alarm ist dann außerhalb der definierten Zeiten aktiv.',
    auto_arm_toggle: 'Geplante Bewegungserkennung aktivieren',
    auto_arm_from: 'Von',
    auto_arm_to: 'Bis',
    auto_arm_outside: 'Außerhalb der Zeiten',
    save: 'Speichern',
    saved: 'Einstellungen gespeichert!',
  },
  settings: {
    title: 'Einstellungen',
    section_account: 'Konto',
    account_name_label: 'Kontoname',
    account_name_placeholder: 'Ihr Name',
    section_security: 'Sicherheit',
    current_pwd: 'Aktuelles Passwort',
    new_pwd: 'Neues Passwort',
    confirm_pwd: 'Passwort bestätigen',
    pwd_mismatch: 'Passwörter stimmen nicht überein.',
    pwd_wrong_current: 'Aktuelles Passwort ist falsch.',
    pwd_changed: 'Passwort aktualisiert.',
    section_preferences: 'Einstellungen',
    date_format_label: 'Datumsformat',
    date_dmy: 'TT/MM/JJJJ',
    date_mdy: 'MM/TT/JJJJ',
    distance_label: 'Entfernungseinheit',
    unit_km: 'Kilometer',
    unit_miles: 'Meilen',
    section_language: 'Sprache',
    lang_fr: 'Français',
    lang_en: 'English',
    lang_it: 'Italiano',
    lang_es: 'Español',
    lang_nl: 'Nederlands',
    lang_de: 'Deutsch',
    save: 'Speichern',
    saved: 'Gespeichert!',
    name_error: 'Aktualisierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    section_push: 'Push-Benachrichtigungen',
    push_types: {
      motion: 'Bewegungsalarm',
      sos: 'SOS-/Panikalarm',
      power: 'Batterie schwach',
      fence: 'Zonen-Benachrichtigungen',
    },
  },
  logs: {
    modal_title: 'Protokolle',
    type_alerts: 'Gesendete Alarme',
    type_commands: 'Gesendete Befehle',
    date_from: 'Von',
    date_to: 'Bis',
    load_btn: 'Laden',
    loading: 'Laden…',
    no_device: 'Wählen Sie ein Gerät aus, um seine Protokolle anzuzeigen.',
    no_data: 'Keine Daten für diesen Zeitraum.',
    col_date: 'Datum',
    col_sent_time: 'Sendezeit',
    col_device: 'Gerät',
    col_recipient: 'Empfänger',
    col_command: 'Befehl',
    col_status: 'Status',
    col_send_time: 'Sendezeit',
    col_delivered_time: 'Zustellzeit',
    col_ack_time: 'Bestätigungszeit',
    col_channel: 'Kanal',
    status_sent: 'Gesendet',
    status_delivered: 'Zugestellt',
    status_acked: 'Bestätigt',
    status_pending: 'Ausstehend',
    col_message: 'Nachricht',
    error: 'Fehler beim Laden der Protokolle.',
    share_placeholder: 'Per E-Mail senden…',
    share_btn: 'Senden',
    share_sending: 'Wird gesendet…',
    share_sent: 'E-Mail gesendet!',
    share_error: 'Fehler beim Senden der E-Mail.',
  },
};

export const TRANSLATIONS: Record<'fr' | 'en' | 'it' | 'es' | 'nl' | 'de', Translations> = { fr, en, it, es, nl, de };
